export const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ123456789";
export const number = "123456789";

export const addresses = [
    "SH & WS COMPANY LIMITED,15 Hearle Way, Hatfield, England, AL10 9EW",
    "HRX PEOPLE LIMITED,1st Floor Kingsway House, Kingsway, Burnley, Lancashire, England, BB11 1BJ",
    "RPT 1107 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "LA PEPIA LIMITED,3 Athenaeum Road, London, United Kingdom, N20 9AA",
    "PLAYLIVEARTIST LTD,27 Old Gloucester Street, London, United Kingdom, WC1N 3AX",
    "LAVENDERISHING SOLUTIONS LTD,56c Kenilworth Drive, Oadby, Leicester, England, LE2 5LG",
    "STEMLIMAS LTD,Unit 24 Space Business Centre, Smeaton Close, Aylesbury, United Kingdom, HP19 8FJ",
    "ATHENA STUDIO LTD,9 North Street, Stamford, England, PE9 1EL",
    "HOUSE OF CONSULTANTS LTD,16 Commerce Square, Nottingham, England, NG1 1HS",
    "MAZDR PROPERTY LTD,19 Ashford Road, Ashford, Middlesex, United Kingdom, TW15 1UB",
    "ATLANTIC ENERGY PARTNERS LTD,23 23, Leighfield Drive, Sunderland, Tyne And Wear, England, SR3 2DD",
    "HRBR HOLDINGS LTD,33-35 Exchange Street, Driffield, England, YO25 6LL",
    "RPT 1122 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "SARVA INVESTMENTS LTD,2nd Floor, 167-169 Great Portland Street, London, United Kingdom, W1W 5PF",
    "CIRCUS RESTAURANT BATH LTD,141 Englishcombe Lane, Bath, United Kingdom, BA2 2EL",
    "SUPERIOR ACCESSORIES LTD,12 Union Street, Reading, England, RG1 1EU",
    "GBS 111 LIMITED,50 Nevett Street Perivale, Preston, England, PR1 4RD",
    "AROHANUI VENTURES LTD,45 Stoke Lane, Westbury-On-Trym, Bristol, England, BS9 3DW",
    "J.E. NAILS AND BEAUTY LTD,213 Whitley Road, Whitley Bay, Tyne And Wear, England, NE26 2SY",
    "BIRCHLAND (EAST ANGLIA) LTD,The Old Forge, 37 East Street, Colchester, England, CO1 2TP",
    "POCKET PAL BUSINESS MANAGEMENT LTD,Unit C2 Sheaf Bank Business Park 20 Prospect Road, Heeley, Sheffield, England, S2 3EN",
    "DAVID&RYAN LTD,25 Wigginton Avenue, Wembley, England, HA9 6EZ",
    "TOOLBOX IRONMONGER LTD,Unit 60 Mill Mead Road, London, England, N17 9QU",
    "MOBILE COMMERCIAL WASH LTD,8 Wyre Close, Whitefield, Manchester, England, M45 8LX",
    "EXEC GROOMING LTD,36 Alie Street, London, England, E1 8DA",
    "SCALNIMI LTD,Unit 24 Space Business Centre, Smeaton Close, Aylesbury, United Kingdom, HP19 8FJ",
    "VANILLE SHINE LTD,60 Charles Street, Suite 402, Leicester, United Kingdom, LE1 1FB",
    "UK TRACE HEATING LTD,Unit 5 Bowthorpe Employment Area, Norwich, England, NR5 9JR",
    "RPT 1125 LIMITED,1-6 Olympia Mews, London, England, W2 3SA",
    "WELLAPHRO LTD,Unit 24 Space Business Centre, Smeaton Close, Aylesbury, United Kingdom, HP19 8FJ",
    "L & Z MEDIA LTD,1 Little East Field, Coulsdon, England, CR5 1NX",
    "SCUTCHES LIMITED,5 Technology Park Colindeep Lane, Colindale, London, United Kingdom, NW9 6BX",
    "APLECT LTD,First Floor Rear Office, 13 Comberton Hill, Kidderminster, DY10 1QG",
    "TREHARNE CONSULTING LIMITED,23 Heol Coed Cae, Whitchurch, Cardiff, Wales, CF14 1HJ",
    "TURKISH DELIGHT BH LTD,51 Bethel Street, Brighouse, England, HD6 1JR",
    "CALTONIAN ELECTRICAL LIMITED,130 Old Street, London, England, EC1V 9BD",
    "STRATTA COMMUNICATIONS LIMITED,Merry Boys Farmhouse Cooling Common, Cliffe, Rochester, England, ME3 7TJ",
    "LAKESIDE HOME & GIFTS LIMITED,Suite 3 12 Princess Street, Knutsford, Cheshire, England, WA16 6DD",
    "OVI & ANDREEA LOGISTICS LIMITED,46 Berkeley Crescent, Barnet, England, EN4 8BS",
    "NEWO RECORDS LIMITED,310-312 Charminster Road, Bournemouth, Dorset, England, BH8 9RT",
    "SM GELATOS LTD,363a Dunstable Road, Luton, England, LU4 8BY",
    "TOCKA CONSTRUCTION LTD,15 Endersleigh Gardens, London, England, NW4 4RX",
    "MEGA BITZ LIMITED,4 Lambert Street, Hull, England, HU5 2SJ",
    "SURREY PROPCO LIMITED,83 Fairlane Drive, South Ockendon, England, RM15 5FA",
    "UNIQUE SPARK LTD,56c Kenilworth Drive, Oadby, Leicester, England, LE2 5LG",
    "ALL IN HAND LTD,24 High Street Green, Hemel Hempstead, Hertfordshire, United Kingdom, HP2 7AQ",
    "VIVACE GYMNASTICS LTD,2 Mere Close, Orpington, England, BR6 8ES",
    "GARTLAND-WOOD INVESTMENTS LIMITED,Stafford Lawn Stafford Road, Stafford Road, Halifax, England, HX3 0PA",
    "FLUENT IN FINTECH LTD,300 Vauxhall Bridge Road, London, England, SW1V 1AA",
    "INNOVATION FOR CHANGE LTD,16 Leicester Grove, Evesham, England, WR11 4QB",
    "THE LEGENDS BOX LTD,22 Harbour View Road, Poole, England, BH14 0PE",
    "RPT 1126 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "SNAZUI649 LTD,259 Westrow Drive, Barking, England, IG11 9BU",
    "DAVID&GARCIA LIMITED,72 Prebend Street, London, England, N1 8PR",
    "SINEWAVE GROUP HOLDINGS LIMITED,Unit B1 Elgin Industrial Estate, Kembrey Street, Swindon, United Kingdom, SN2 8UY",
    "SECURISAFE LTD,33 Cavendish Gardens, Barking, Essex, United Kingdom, IG11 9DR",
    "SANDRA'S CAFE & BAR LTD,1 The Droveway, St. Margarets Bay, Dover, England, CT15 6DH",
    "NV AESTHETICS LTD,87 Dominion Road, Glenfield, Leicester, England, LE3 8FE",
    "GRAY LION LIMITED,60 Mill Mead Road, London, England, N17 9QU",
    "RPT 1130 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "RPT 1129 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "ALLWORK SOLUTIONS LIMITED,12 Hatherley Road, Sidcup, Kent, United Kingdom, DA14 4DT",
    "ASHLEY T LAW LTD,The Long Barn Down Barton Road, St. Nicholas At Wade, Birchington, England, CT7 0PZ",
    "RPT 1115 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "CONNECT 4 GROUP B2B LIMITED,8 Bankart Avenue, Leicester, England, LE2 2DB",
    "K DISPLAYS LIMITED,Concept House, Milner Way, Ossett, England, WF5 9JE",
    "RPT 1120 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "JOSEPH CAMM FARMS INVESTMENTS LIMITED,Upper Morton Babworth, Retford, Nottinghamshire, England, England, DN22 8HG",
    "LIBERTY LETTINGS & PROPERTY MANAGEMENT LTD,61 Bridge Street, Kington, United Kingdom, HR5 3DJ",
    "SKY BUYS CARS LIMITED,5 Ogwen Drive, Cardiff, Wales, CF23 6LH",
    "RPT 1128 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "WORTHINGTON CHERRYLAKE LTD,56c Kenilworth Drive, Oadby, Leicester, England, LE2 5LG",
    "EDEN HOME SERVICES LIMITED,357 Eaton Road, West Derby, Liverpool, England, L12 2AH",
    "L&PH LIMITED,57 Belvedere Avenue, Stockport, England, SK5 6QJ",
    "BLUE X ROCK SOLUTIONS LTD,56c Kenilworth Drive, Oadby, Leicester, England, LE2 5LG",
    "JOLIE PURSE LIMITED,167-169 London (W1w 5pe) Office, 167-169 Great Portland Street, London, United Kingdom, W1W 5PE",
    "RPT 1133 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "SIAMATILDAGBEKIE LIMITED,101 Town Street, Rotherham, England, S60 2JW",
    "KHADIJAH & SAL LIMITED,40 Waterhall Close, London, United Kingdom, E17 5PS",
    "FROMTHEMAKERS LTD,63/66 Hatton Garden, Fifth Floor, Suite 23, London, United Kingdom, EC1N 8LE",
    "RAHIMA EXPRESS LIMITED,Unit-A, 12 Vallance Road, 2nd Floor, London, England, E1 5HR",
    "RPT 1131 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "RPT 1121 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "RPT 1132 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "GBS 45 LIMITED,56 Bolton Road, Harrow, England, HA1 4SA",
    "CFSSAS LTD,D N S House, 382 Kenton Road, Harrow, Middlesex, United Kingdom, HA3 8DP",
    "BOWLAND BROOKS ENVIRONMENT LIMITED,Unit A 1 Station Road, Guiseley, Leeds, England, LS20 8BX",
    "WATERS RISK SERVICES LTD,Union House, 111 New Union Street, Coventry, England, CV1 2NT",
    "O&C COMFORTS LTD,38 Somerset Drive, Duston, Northampton, England, NN5 6FA",
    "SO HOSPITALITY GROUP LIMITED,60 The Ridings, London, United Kingdom, W5 3DR",
    "PROJECT SOLVED LTD,25 Heathfield South, Twickenham, England, TW2 7SR",
    "CHARINCO LTD,60 Charles Street, Suite 402, Leicester, United Kingdom, LE1 1FB",
    "WOOFINGTON BOUTIQUE LTD,44 Welwyn Park Road, Hull, United Kingdom, HU6 7EB",
    "HI TRANSPORTATION LIMITED,Avix Business Centre C/O Sbe Accountants Ltd, 42 - 46 Hagley Road, Birmingham, West Midlands, United Kingdom, B16 8PE",
    "MERSTON ELECTRIC (UK) LIMITED,291 Brighton Road, South Croydon, United Kingdom, CR2 6EQ",
    "DENISBRIANA LTD,43 Flat 1, Fosse Road South, Leicester, England, LE3 0QD",
    "DISTINCT ADVANTAGE LTD,64 Nile Street, London, England, N1 7SR",
    "THE 4X4 SPECIALISTS LTD,Colbrook House Old London Road, Coldwaltham, Pulborough, England, RH20 1LF",
    "BROO LIMITED,Flat 16 Berkley Court, 43 Berkley Street, Birmingham, England, B1 2LF",
    "PHAB AVIATION LTD,2 Batchelor Green, Lowford, Bursledon, Southampton 2 Batchelor Green, Bursledon, Southampton, Hampshire, England, SO31 8FJ",
    "TWENTY20 CLEANING LIMITED,84 Ilex Close, Colchester, England, CO2 9QE",
    "OATEN GROUP LIMITED,109 Bushmead Road, Luton, England, LU2 7YT",
    "HILL NORTH LTD,Stub Thorn Farm, Maunby, Thirsk, North Yorkshire, England, YO7 4HQ",
    "YAM FABRIC LIMITED,1e Queens Road, Manchester, England, M8 8UQ",
    "CHERISHMAY SOLUTIONS LTD,56c Kenilworth Drive, Oadby, Leicester, England, LE2 5LG",
    "JOE ARMITAGE DESIGN LTD,Flat 66 Keeling House, Claredale Street, London, England, E2 6PG",
    "LS ACCOUNTANTS SERVICES LTD,3rd Floor, Office Suite 17-316e Ilford Lane,Ilford Ilford Lane, Ilford, England, IG1 2LT",
    "MAKO REMOVALS SERVICES LIMITED,23a Earlham Grove, London, England, E7 9AL",
    "CHEESY MACKS LIMITED,1e Mentmore Terrace, London, England, E8 3DQ",
    "FACTORY 1968 LTD,14b Oxford Gardens, London, England, W4 3BW",
    "RPT 1136 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "NOIISE N WORK4.0 LTD,24a Bartholomew Villas, London, England, NW5 2LL",
    "TRES MAESTROS LTD,352 Fulham Road, London, United Kingdom, SW10 9UH",
    "H K DHATT TRANSPORT COMPANY LTD,112 Carlyon Road, Hayes, Middlesex, United Kingdom, UB4 0NU",
    "LVH MOTORS LIMITED,177 Park Avenue Princes Avenue, Hull, England, HU5 4DE",
    "GP UK LOGISTICS LTD,Flat 96 Zenith House, 69 Lawrence Road, London, England, N15 4GB",
    "VICINITY WIRELESS LIMITED,116 Church Road, Redfield, Bristol, England, BS5 9LJ",
    "VAKANT STUDIOS LTD,5 Lewis Avenue, Walthamstow, Walthamstow, London, United Kingdom, E17 5BL",
    "TRACE HEATING UK LIMITED,Unit 5 Bowthorpe Employment Area, Norwich, England, NR5 9JR",
    "L A MACKENZIE LIMITED,30 Nansen Avenue, Poole, England, BH15 3DB",
    "AJAMERO LTD,2 Solihull Lane, Birmingham, England, B28 9LU",
    "SAFRA BRASIL, LTD.,20-22 Wenlock Road, London, England, N1 7GU",
    "ALCRAFT WOODWORKS LTD,20 Downhills Way, London, England, N17 6BA",
    "MOON PHASE STUDIO LTD,2 Homefield Court Short Cross Road, Mount Hawke, Truro, England, TR4 8DU",
    "BETENGINE LTD,27 Old Gloucester Street, London, United Kingdom, WC1N 3AX",
    "RPT 1137 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "KWDS SERVICES LTD,85 River Way, Christchurch, Dorset, United Kingdom, BH23 2QJ",
    "ANNULAR CAPITAL LTD,33 Cathedral Road, Cardiff, United Kingdom, CF11 9HB",
    "FAST PROFESSIONAL REMOVALS LTD,14 Springfield Gardens, London, England, NW9 0RS",
    "ME DADS CHIPPY LTD,9 West Road, Lancaster, England, LA1 5PG",
    "PETIT GRIND LTD,20 Thornhill Gardens, London, England, E10 5EN",
    "ANYWHERE SAMEDAY COURIERS LTD,4 Rowan Close, Northampton, England, NN4 5BP",
    "ATRIUM PROPERTY LTD,11 Rudgard Way, Liphook, Hampshire, England, GU30 7GW",
    "PEOPLE'S LOCAL LTD,20-22 Wenlock Road, London, England, N1 7GU",
    "RPT 1138 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "RECREW LIMITED,Unit B, 30 Commerce Road, Brentford, England, TW8 8LE",
    "TREE OF LIFE LONDON LIMITED,2 Maygrove Road, London, England, NW6 2EB",
    "POSITIVIA LIMITED,3 The Mount, Trumpsgreen Road, Virginia Water, England, GU25 4EJ",
    "KOM LIVING LTD,98 B Blenheim Crescent, London, England, W11 1NZ",
    "ANYWHERE COURIERS LTD,4 Rowan Close, Northampton, England, NN4 5BP",
    "MULTI-STOREY LETS LTD,44 Landells Road, London, England, SE22 9PQ",
    "COSI AND CLEAN LTD,11 Arthur Road, London, England, N9 9AF",
    "VERSALIA LIMITED,1 Second Avenue, Halstead, Essex, England, CO9 2SU",
    "FOOD AND DESERTS CO LTD,9-13 Holbrook Lane, Sterling Accountant Services, Coventry, England, CV6 4AD",
    "64 ELM PARK ROAD LIMITED,21-23 Mossop Street, Chelsea, London, England, SW3 2LY",
    "VISBAN NETWORKS LIMITED,13 The Close, Radlett, England, WD7 8HA",
    "BECKWILLS HOMES LIMITED,83 Sellars Way, Basildon, England, SS15 5LY",
    "ORCHARD FULFILMENT LTD,1st Floor Huxley House, 11 William Street, Redditch, United Kingdom, B97 4AJ",
    "YEI LIMITED,15 Basevi Way, London, England, SE8 3JU",
    "BROWN CONTRACTORS LIMITED,Lynnem House, 1 Victoria Way, Burgess Hill, West Sussex, United Kingdom, RH15 9NF",
    "OAKSHIRE LTD,115 Craven Park Road, London, England, N15 6BL",
    "PORTHMADOG LIMITED,Banks House, 1 Paradise Street, Rhyl, Denbighshire, Wales, LL18 3LW",
    "BUTTON BOUTIQUE (BOLTON) LIMITED,Carlyle House, 78 Chorley New Road, Bolton, United Kingdom, BL1 4BY",
    "MANO’S TRADING & CO LTD,1st Floor 2 Woodberry Grove, Finchley, London, England, N12 0DR",
    "MAREMARE LTD,20-22 Wenlock Road, London, England, N1 7GU",
    "MERSEY ANIMAL HUB LTD,37 Dumbrees Road, Liverpool, England, L12 6RB",
    "C&C RISKS UK LIMITED,The Stables 32 Main Street, Ashley, Market Harborough, United Kingdom, LE16 8HF",
    "HIGH END DESIGN AND BUILD LTD,C/O Kpsg Accountants, 193 Coldharbour Lane, Hayes, United Kingdom, UB3 3EH",
    "JM FIREPROOFING LTD,57 Southend Road, Grays, England, RM17 5NL",
    "ATWOMAA KITCHEN LIMITED,60 Shakespeare Road, Wellingborough, England, NN8 3RL",
    "RPT 1139 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "FROTHYNE LTD,First Floor Rear Office, 13 Comberton Hill, Kidderminster, DY10 1QG",
    "GBS 8 T LIMITED,50 Nevett Street, Preston, England, PR1 4RD",
    "NEKOGAUC LTD,First Floor Rear Office, 13 Comberton Hill, Kidderminster, DY10 1QG",
    "RPT 1135 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "GIBSON CAD SERVICES LTD,86a Market Street, Eastleigh, England, SO50 5RE",
    "SILVIA CARE SERVICES LTD,C/O Aspreys Accountants Suite 211, 1607 Wellington Way, Brooklands Business Park, Weybridge, Surrey, England, KT13 0TT",
    "COMPUTERS FIRST GROUP LTD,71-75 Shelton Street, Covent Garden, London, United Kingdom, WC2H 9JQ",
    "CYBER HOUSE TRADE UK LTD,Peel House, London Road, Morden, England, SM4 5BT",
    "IN STICHES FASHION CONSULTANCY LTD,Unit 60 Millmead Business Centre, Mill Mead Road, London, England, N17 9QU",
    "RPT 1134 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "SAMALYS DELIVERY LTD,13 Orchard Street, Ipswich, England, IP4 2PU",
    "TEAME GROUP LTD,1026 Harrow Road, London, England, NW10 5NN",
    "THE TRAVEL EDIT LIMITED,Woodend Grange, Steane, Brackley, Northamptonshire, England, NN13 5NS",
    "KUULEATS LOCAL LIMITED,Atlantic House Bell Lane, Bellbrook Industrial Estate, Uckfield, England, TN22 1QL",
    "VIP BY G LIMITED,The Mitre, 1-3 Cathedral Gates, Manchester, England, M3 1SW",
    "PAUL BATE CONSULTANCY LIMITED,103b Redston Road, London, England, N8 7HG",
    "WOMEN'S RADIO STATION (LONDON) C.I.C.,16b Jermyn Street, London, England, SW1Y 6ST",
    "ELITE CAPITAL BASKETBALL CIC,16 Boundary Road, London, England, N22 6AD",
    "AB INSTRUMENT DESIGN LTD,4 Ashkirk Road, Normanby, Middlesbrough, United Kingdom, TS6 0EW",
    "ESTONIIA BEAUTY LTD,71-75 Shelton Street, London, Greater London, United Kingdom, WC2H 9JQ",
    "RPT 1123 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "TFJ ENGINEERING SERVICES LIMITED,35 Hilden Park, Stockton-On-Tees, England, TS17 5AJ",
    "STRATFORD WARWICK LTD,86-90 Paul Street, London, England, United Kingdom, EC2A 4NE",
    "MI CASA CO LIVING LIMITED,The Coach House Myrtle Road, Golcar, Huddersfield, West Yorkshire, United Kingdom, HD7 4EF",
    "BRONZE STONE INVESTMENT LTD,113 Gloucester Place, Cejr, London, England, W1U 6JR",
    "MAXWELL STAR PROPERTIES LTD,89 Morborne Close, Manchester, England, M12 4EH",
    "JM MAGIC MAN & CLEANING LTD,57 Southend Road, Grays, England, RM17 5NL",
    "DAKHIL LTD,23a Humes Avenue, London, England, W7 2LJ",
    "E&T DRYLINING LTD,9 Stamford Gardens, Dagenham, England, RM9 4ET",
    "LIQUIDUS ENGINEERING LTD,Basepoint Business Centre Rivermead Drive, Westlea, Swindon, England, SN5 7EX",
    "PRESTON REAL ESTATE LTD,9 Carradale Close, Eaglescliffe, Stockton-On-Tees, Cleveland, United Kingdom, TS16 9HF",
    "UPSHOT SYSTEMS CIC,Top Flat, 96 Algernon Road, London, United Kingdom, SE13 7AW",
    "DOTWAV LTD,27 Parc Gwyn, Trevaughan, Carmarthen, Wales, SA31 3QP",
    "EVAN LUTION CYCLES LTD,1 Kimberley Road, Colchester, England, CO1 2JH",
    "ECOYETI LIMITED,16 Tennyson Road, London, England, SE20 7ND",
    "BUBBLE CARWASH S63 LTD,Carwash Church Street, Wath Upon Dearne, Rotherham, United Kingdom, S63 6RR",
    "RPT 1111 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "BIRBRICKS LTD,81 Longton Grove, London, England, SE26 6QQ",
    "RSB GLOBNET LTD,3 Henry Joy Close, Bournemouth, England, BH9 2FA",
    "GEORGIA MAE BEAUTY LTD,37 Bruce Grove, Wickford, England, SS11 8RE",
    "ECOMETRIS LTD,Kemp House, 160 City Road, London, United Kingdom, EC1V 2NX",
    "RPT 1109 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "LIZZY’S KITCHEN LTD,71-75 Shelton Street, London, Greater London, United Kingdom, WC2H 9JQ",
    "S & BOLDINGS LTD,8 St. Georges Road, London, England, NW11 0LR",
    "RPT 1127 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "TROPICAL LAND LIMITED,26 Cheapside, Wakefield, England, WF1 2TF",
    "BEVELLS HOMES LTD,309 Hoe Street, London, England, E17 9BG",
    "MASPRET LTD,First Floor Rear Office, 13 Comberton Hill, Kidderminster, DY10 1QG",
    "LIM’S SG LTD,24 Nicholas Street, Chester, United Kingdom, CH1 2AU",
    "PAZDZI TRANS LIMITED,29 Cranmore Avenue, Isleworth, England, TW7 4QW",
    "JENU PROPERTIES LTD,12, Bolton Drive Shinfield, Reading, United Kingdom, RG2 9RD",
    "RUEV75 LTD,55 Leigh Road, London, England, E6 2AR",
    "ANANS SYSTEMS LTD,Unit 15 Stapledon Road, Orton Southgate, Peterborough, United Kingdom, PE2 6TD",
    "SMM CARS LIMITED,PO Box 4385, 13016613: COMPANIES HOUSE DEFAULT ADDRESS, Cardiff, CF14 8LH",
    "GURO KREMPIG - FRILUFTSGLEDE LIMITED,Stron Legal, The Clubhouse St James, 8 St James's Square, St James's, London, United Kingdom, SW1Y 4JU",
    "BROOMFIELD PARK MANAGEMENT COMPANY LIMITED,Holt Barn, Poundisford, Taunton, United Kingdom, TA3 7AE",
    "AM CONSULTING E.U. LTD,20-22 Wenlock Road, London, England, N1 7GU",
    "CNTRL TRADING LIMITED,27 Old Gloucester Street, London, England, WC1N 3AX",
    "FITSE CONNECT LIMITED,98 Godstone Road, Kenley, England, CR8 5AB",
    "HILL AND VATTANI LIMITED,Flat 6 Lyden Court, 642 Holloway Road, London, United Kingdom, N19 3NU",
    "LONDON BESPOKE TILING SOLUTIONS LTD,40 Bellingham Road, London, England, SE6 2PT",
    "TARUN CHADHA PROPERTIES LIMITED,Mantra, Leek Road, Stoke-On-Trent, England, ST9 0DQ",
    "ALI ENTERPRISE ASHTON LTD,1062 Ashton New Road, Manchester, Lancashire, United Kingdom, M11 4PE",
    "GARDEN CONSERVATION LIMITED,Flat 11 60 Barge Walk, London, England, SE10 0UG",
    "RPT 1140 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "PGS PROPERTYS LTD,4 Burnside Road, Darlington, United Kingdom, DL1 4SA",
    "RPT 1110 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "RUBY DEAN LTD,36 St. Bees Close, Manchester, England, M14 4GG",
    "CHICKEN N RIBS LTD,5 Chard Terrace, Falmouth, England, TR11 2RE",
    "KREMPIG INVEST LIMITED,Stron Legal, The Clubhouse St James, 8 St James's Square, St James's, London, United Kingdom, SW1Y 4JU",
    "MAKAN GROUP LTD,6 Watervale, Houghton Regis, Dunstable, England, LU5 6FY",
    "LEGENDHAIRY LTD,31 Suffolk Road, Enfield, London, Suffolk Road, Enfield, England, EN3 4AY",
    "EVALCO LTD,71-75 Shelton Street, Covent Garden, London, United Kingdom, WC2H 9JQ",
    "SANVI HOMES LTD,85 Barnfield Gardens Plumstead Common Road, London, England, SE18 3QY",
    "ROCKFIELD HOMES LTD,3 Rose Cottages, Redbrook, Monmouth, Wales, NP25 4LW",
    "FUNKY PAW LTD,193a Ashley Road, Hale, Altrincham, United Kingdom, WA15 9SQ",
    "T RUSHBROOK GROUP LTD,Office 1 Unit 12, Rawreth Lane, Rayleigh, Essex, United Kingdom, SS6 9RL",
    "PAYOLOGY LIMITED,York Eco Business Centre (Unit 12), Amy Johnson Way, York, England, YO30 4AG",
    "VGMAX.SERVICES. LTD,250a Wood Street, Walthamstow, London, England, E17 3NA",
    "ENDZONE SPORTS LTD,78a The Broadway, London, United Kingdom, SW19 1RQ",
    "CHIR SOL WAY LTD,56c Kenilworth Drive, Oadby, Leicester, England, LE2 5LG",
    "LUKE MACE LTD,28 Harborough Road, Maidwell, Northampton, England, NN6 9JA",
    "SCHOFIELD ELECTRICAL CONTRACTORS LIMITED,76 Manchester Road, Denton, Manchester, England, M34 3PS",
    "CAREERBUD LTD,Anchor Cottage Goose Green, Gomshall, Guildford, England, GU5 9LL",
    "34 MILWARD CRESCENT RTM COMPANY LIMITED,28 Hyde Gardens, Eastbourne, East Sussex, United Kingdom, BN21 4PX",
    "GLOBAL MONEY AND TRAVEL LTD,122 High Street, Southend-On-Sea, United Kingdom, SS1 1JT",
    "TSB ROOFING & CLADDING LIMITED,8 Castlegate, Tickhill, Doncaster, England, DN11 9QU",
    "CHADART LIMITED,71-75 Shelton Street, Covent Garden, London, England, WC2H 9JQ",
    "THE LIGHTHOUSE - ARTS AND WELLBEING COMMUNITY INTEREST COMPANY,359 Blackburn Road, Oswaldtwistle, Accrington, England, BB5 4NA",
    "JOHNSON HEALTHCARE SERVICES LIMITED,10 Darter View, Nuneaton, England, CV10 9GN",
    "THE FAMILY PUB GROUP LTD,Ash Cottage Oxford Road, Steeple Aston, Bicester, England, OX25 5QH",
    "SPECIALISM LIMITED,29 Gildredge Road, Eastbourne, East Sussex, United Kingdom, BN21 4RU",
    "APRICOT ESTATES LTD,46 Shaftesbury Gardens, London, England, NW10 6LJ",
    "WISORY LTD,71-75 Shelton Street, London, Greater London, United Kingdom, WC2H 9JQ",
    "GMV EXPRESS LTD,25 Donney Brook, Evesham, England, WR11 1YD",
    "COMEIR THIN LTD,56c Kenilworth Drive, Oadby, Leicester, England, LE2 5LG",
    "BUILD & DESIGN LONDON LIMITED,24 Partridge Close, London, England, E16 3TB",
    "SPRAY SOLUTIONS SWANSEA LIMITED,V3 Accounting Solutions Ltd, 10, St. Helens Road, Swansea, West Glamorgan, United Kingdom, SA1 4AW",
    "MADE SIMPLE FINANCE LIMITED,Wey House 15 Church Street, Suite 177, Weybridge, England, KT13 8NA",
    "AVIDEN LIMITED,71-75 Shelton Street, Covent Garden, London, England, WC2H 9JQ",
    "CARTWHEEL COFFEE ROASTERS LTD,Unit S1, Roden House, Roden Street, Nottingham, United Kingdom, NG3 1JH",
    "ANNOUK LTD,2e Parkinson Road, Liverpool, United Kingdom, L9 1DL",
    "THE HUMBLE LINE LTD,Thatched Cottage Green Street, Little Hadham, Ware, England, SG11 2EE",
    "EDWARD THOMPSON SERVICES LIMITED,76 Market Street, Farnworth, Bolton, Lancashire, United Kingdom, BL4 7NY",
    "FB PROPERTIES (YORK) LTD,2 Clifton Moor Business Village, James Nicolson Link, York, North Yorkshire, England, YO30 4XG",
    "RUSH NETWORKS PROPERTIES (THREE) LIMITED,25 George Street, Croydon, United Kingdom, CR0 1LB",
    "CALVERY LIMITED,159 Heather Road, Fawley, Southampton, England, SO45 1EW",
    "SOLE SISTAS LTD,20-22 Wenlock Road, London, England, N1 7GU",
    "AKI PIZZERIA LTD,242 Marton Road, Middlesbrough, United Kingdom, TS4 2EZ",
    "INCOTECH TECHNOLOGY SOLUTIONS LTD,60 Mill Mead Business Centre, Mill Mead Road, London, England, N17 9QU",
    "AI PROPERTY GROUP (MIDLANDS) LTD,46a Edgbaston Road, Birmingham, England, B12 9PB",
    "GRABTALENTS LTD,86-90 Paul Street, London, England, United Kingdom, EC2A 4NE",
    "MARIUS ACHIHAEI LTD,23 Harrison Road, Flat 3, Birmingham, England, B24 9AB",
    "CARGO ST LTD,56c Kenilworth Drive, Oadby, Leicester, England, LE2 5LG",
    "RKS VENTURES LIMITED,1st Floor, 44-50 The Broadway, Southall, Middlesex, United Kingdom, UB1 1QB",
    "UNIQ FIRST LTD,Dept 2 43 Owston Road, Carcroft, Doncaster, England, DN6 8DA",
    "J K ALEXANDER LTD,6 The Old Quarry, Nene Valley Business Park, Oundle, Peterborough, England, PE8 4HN",
    "COMEIR THURS LTD,56c Kenilworth Drive, Oadby, Leicester, England, LE2 5LG",
    "EMPIRE SERVICES GLOBAL LIMITED,Flat 196 Paxton Court Manor Way, Borehamwood, Hertfordshire, United Kingdom, WD6 2AA",
    "SI DESMOND LTD,56c Kenilworth Drive, Oadby, Leicester, England, LE2 5LG",
    "COMET WIND LTD,56c Kenilworth Drive, Oadby, Leicester, England, LE2 5LG",
    "VURALEX LTD,41 Trinity Street, Norwich, Norfolk, United Kingdom, NR2 2BH",
    "EVEN BTTR LTD,3rd Floor, 86-90 Paul Street, London, England, EC2A 4NE",
    "DRIPPY CUTS LIMITED,Flat 6 Farmstead Court, 6 Melbourne Road, Wallington, England, SM6 8SY",
    "CINNERBY LIGHT LTD,60 Charles Street, Suite 402, Leicester, United Kingdom, LE1 1FB",
    "BUSINESS RENEGADE LTD,20-22 Wenlock Road, London, England, N1 7GU",
    "CONRAD S SOLUTIONS LTD,56c Kenilworth Drive, Oadby, Leicester, England, LE2 5LG",
    "YOUNGN'S LIMITED,22 Hanover Avenue, Feltham, England, TW13 4JW",
    "BEAUTY & NAILS @ BIANCA LIMITED,28 Western Street, Swindon, England, SN1 3JR",
    "PEONY SILK LTD,71-75 Shelton Street, Covent Garden, London, England, WC2H 9JQ",
    "AW SOFTS LTD,397 182-184 High Street North, East Ham, London, United Kingdom, E6 2JA",
    "EASY FIX AUTO CENTER LTD,71-73, Unit 17 Nathan Way, London, United Kingdom, SE28 0BQ",
    "PINK & BLUE BEAUTY ROOMS LTD,Second Floor Genesis House 1-2 The Grange, High Street, Westerham, England, TN16 1AH",
    "EMPORIA FURNISHINGS LTD,7 Gordons Close, Stithians, Truro, England, TR3 7BG",
    "DALLIER LIMITED,145 Knighton Road, Leicester, England, LE2 3TS",
    "THE SHOP AT BROADWAY LTD,1 To 1 Accountancy Services Ltd, Venta House, 9a Port Road, Newport, Gwent, United Kingdom, NP20 2NS",
    "RPT 1112 LIMITED,Unit 9 Pickford Street, Birmingham, England, B5 5QH",
    "BUILD IN TOYS LTD,71-75 Shelton Street, London, Greater London, United Kingdom, WC2H 9JQ",
    "BEST MOMENTS OF YOUR LIFE LTD,Flat 39 Stanway Court, Geffrye Estate, London, England, N1 6RY",
    "WK CREATIVE LIMITED,Flat 3 42 Queen's Road, Coventry, CV1 3EH",
    "ANNULA (10) LTD,33 Cathedral Road, Cardiff, United Kingdom, CF11 9HB",
    "THE CROOKED BILLET LTD,Studio 210 134-146 Curtain Road, London, England, EC2A 3AR",
    "MOUNT GLIDE LTD,71-75 Shelton Street, Covent Garden, London, United Kingdom, WC2H 9JQ",
    "EXCELDEC LIMITED,15 Chancelot Road, London, England, SE2 0NB",
    "SUPERSAUCE LTD,58 Lynett Road, Dagenham, England, RM8 1RL",
    "LUNA:LABORATORIES LTD,20-22 Wenlock Road, London, England, N1 7GU",
    "INKIUM LTD,122, Rock Vaper Scissors High Street South, London, United Kingdom, E6 3RW",
    "PHOENIX WELL-BEING GYM LTD,Old Squash Courts, Phoenix Well-Being Gym, Rail Mill Lane, Cwmavon, United Kingdom, SA12 9DL",
    "WONK BRIDGE LTD.,Flat 5 Sirius House, Seafarer Way, London, England, SE16 7DR",
    "CONSOLE LTD,Rh 115 The Record Hall, 16-16a Baldwins Gardens, London, England, EC1N 7RJ",
    "TOWN HEROINE LTD,Edmund Court, Magazine Road, Wirral, United Kingdom, CH62 3AD",
    "GHL (LEEGATE) LIMITED,3rd Floor, Sterling House, Langston Road, Loughton, Essex, United Kingdom, IG10 3TS",
    "ANNULA (5) LTD,33 Cathedral Road, Cardiff, United Kingdom, CF11 9HB",
    "MK1 TRAINING CENTRE LTD,1st Floor, Castle House, Dawson Road, Milton Keynes, England, MK1 1QT",
    "TH CONTENT LTD,119 Shelford Road, Gedling, Nottingham, England, NG4 4JG",
    "SPA WELL HOUSE LIMITED,66a Hutton Lane, Guisborough, England, TS14 6QP",
    "SATISFY SALON AND TRAINING SCHOOL LTD.,Studio 210 134-146 Curtain Road, London, England, EC2A 3AR",
    "CONSTRUCTIVE ART SUPPLIES LTD,28 Wilton Road, Bexhill On Sea, East Sussex, England, TN40 1EZ",
    "DEVOPS CLOUD PRO IT SOLUTIONS LIMITED,16 Saberton Close, Redbourn, St. Albans, England, AL3 7DS",
    "SUN & INK LIMITED,43 Liverpool Road South, Liverpool, England, L31 7BN",
    "RVLT BUSINESS INV LTD,Office 4 219 Kensington High Street, Kensington, London, England, W8 6BD",
    "DESMONA M LTD,56c Kenilworth Drive, Oadby, Leicester, England, LE2 5LG",
    "AMARAIN LTD,6 Pearl Place, Birmingham, England, B19 1QE",
    "COSWELL UK LIMITED,5th Fl, Aldermary House, 10-15 Queen Street, C/O Pirola Pennuto Zei &amp; Associati, London, United Kingdom, EC4N 1TX",
    "BIAOYANG LTD,15-17 Upper George Street, Connaught House, Luton, Bedfordshire, United Kingdom, LU1 2RD",
    "L & R DESIGN AND BUILD LIMITED,Abacus Court Bull Street, Harborne, Birmingham, England, B17 0HH",
    "QUALITY FRUIT & VEG (WHOLESALE) LIMITED,Spectrum House, 2b Suttons Lane, Hornchurch, Essex, United Kingdom, RM12 6RJ",
    "ARTUS CAPITAL LIMITED,Eden House, Reynolds Road, Beaconsfield, United Kingdom, HP9 2FL",
    "TEKKERS LEISURE LIMITED,Omega Court, 350 Cemetery Road, Sheffield, South Yorkshire, United Kingdom, S11 8FT",
    "T HALLY TRANS LTD,32 Blake Street, Stoke On Trent, England, ST6 4BE",
    "RM ECOMMERCE LTD,80-83 Long Lane, London, England, EC1A 9ET",
    "CINNY WAY LTD,56c Kenilworth Drive, Oadby, Leicester, England, LE2 5LG",
    "VIKZU LIMITED,4th Floor Silverstream House, 45 Fitzroy Street, Fitzrovia, London, United Kingdom, W1T 6EB",
    "DIBSTUFF LTD,20-22 Wenlock Road, London, England, N1 7GU",
    "UNCOMMON BEAUTY LTD,20-22 Wenlock Road, London, England, N1 7GU",
    "WE JUST RECYCLE LIMITED,16 School Way, Llanfoist, Abergavenny, Gwent, United Kingdom, NP7 9FD",
    "OSCAR LOGISTICS SERVICES LIMITED,Flat 3 ,254 Battersea Park Road, London, England, SW11 3BP",
    "HFL DESIGN LIMITED,2a Stanton Road, London, England, SW13 0EX",
    "WOODVINE CHERRY LTD,56c Kenilworth Drive, Oadby, Leicester, England, LE2 5LG",
    "UNMISSABLE SEO LTD,20-22 Wenlock Road, London, England, N1 7GU",
    "HARDY STONE LTD,636-638 Allerton Road, Allerton, Bradford, England, BD15 8AB",
    "DESSERT FRANCHISE LTD,Unit 3 Station Street East, Coventry, England, CV6 5FR",
    "TECMEN LTD,2 Woodcroft Avenue, London, United Kingdom, NW7 2AG",
    "BEAUTYFUEL LIMITED,142-143 Parrock Street, Gravesend, Kent, England, DA12 1EY",
    "RUSH BLUE PROPERTIES (TWO) LIMITED,25 George Street, Croydon, United Kingdom, CR0 1LB",
    "JH SIGNALLING SOLUTIONS LTD,49 49 Brookhey, Hyde, England, SK14 2DY",
    "RDRF LTD,Silverstone Park Innovation Centre Silverstone Circuit, Silverstone, Towcester, England, NN12 8GX",
    "VIRTUALLY HERE SOLUTIONS LIMITED,4, Partridge Way, Wood Green, London, England, United Kingdom, N22 8DW",
    "CASIERS SECURISES LIMITED,26 Royal Road, Teddington, Middlesex, United Kingdom, TW11 0SB",
    "CONSTRUCTIVE SHOP LTD,28 Wilton Road, Bexhill On Sea, East Sussex, England, TN40 1EZ",
    "GASTON CHAPELLE LIMITED,Metro House, 57 Pepper Road, Leeds, England, LS10 2RU",
    "MONOCLE LIMITED,19 Barnes High Street, Barnes, London, England, SW13 9LW ",
];

export const arabCountry = ['TN', 'BH', 'KW', 'IQ', 'QA', 'OM', 'MA', 'SA', 'LB', 'LY', 'AE', 'DZ', 'EG'];

// export const countryData = [
//     {
//         name: "GH",
//         code: 233,
//         minLengthTel: 5,
//         nameLabel: 'FOR EXAMPLE: ANDRÉS SANCHEZ',
//         namePlaceholder: 'First Name & Last Name',
//         phoneLabel: 'FOR EXAMPLE: +233 933 543 342',
//         phonePlaceholder: 'Mobile Number',
//         buttonSumbitText: 'rush my order',
//         doubleOrderAlert: 'You have already applied!',
//     },
//     {
//         name: "UG",
//         code: 256,
//         minLengthTel: 5,
//         nameLabel: 'FOR EXAMPLE: ANDRÉS SANCHEZ',
//         namePlaceholder: 'First Name & Last Name',
//         phoneLabel: 'FOR EXAMPLE: +256 933 543 342',
//         phonePlaceholder: 'Mobile Number',
//         buttonSumbitText: 'rush my order',
//         doubleOrderAlert: 'You have already applied!',
//     },
//     {
//         name: "AM",
//         code: 374,
//         minLengthTel: 5,
//         nameLabel: 'Օրինակ ՝ Տորք Աբդուլա',
//         namePlaceholder: 'Ձեր անունը',
//         phoneLabel: 'Օրինակ: +374 93 54 344',
//         phonePlaceholder: 'Մուտքագրեք հեռախոսը',
//         buttonSumbitText: 'Պատվիրել',
//         doubleOrderAlert: 'Դուք արդեն դիմել եք:',
//     },
//     {
//         name: "DO",
//         code: 1809,
//         minLengthTel: 5,
//         nameLabel: 'POR EJEMPLO: ANDER SANCHEZ',
//         namePlaceholder: 'Su nombre',
//         phoneLabel: 'POR EJEMPLO: +1809 933 543 342',
//         phonePlaceholder: 'Ingrese su numero de telefono',
//         buttonSumbitText: 'Pedir',
//         doubleOrderAlert: '¡Ya has presentado tu solicitud!',
//     },
//     {
//         name: "TZ",
//         code: 255,
//         minLengthTel: 5,
//         nameLabel: 'FOR EXAMPLE: ANDRÉS SANCHEZ',
//         namePlaceholder: 'First Name & Last Name',
//         phoneLabel: 'FOR EXAMPLE: +255 933 543 342',
//         phonePlaceholder: 'Mobile Number',
//         buttonSumbitText: 'rush my order',
//         doubleOrderAlert: 'You have already applied!',
//     },
//     {
//         name: "SV",
//         code: 503,
//         minLengthTel: 5,
//         nameLabel: 'POR EJEMPLO: ANDER SANCHEZ',
//         namePlaceholder: 'Su nombre',
//         phoneLabel: 'POR EJEMPLO: +503 933 543 342',
//         phonePlaceholder: 'Ingrese su numero de telefono',
//         buttonSumbitText: 'Pedir',
//         doubleOrderAlert: '¡Ya has presentado tu solicitud!',
//     },
//     {
//         name: "HN",
//         code: 504,
//         minLengthTel: 5,
//         nameLabel: 'POR EJEMPLO: ANDER SANCHEZ',
//         namePlaceholder: 'Su nombre',
//         phoneLabel: 'POR EJEMPLO: +504 933 543 342',
//         phonePlaceholder: 'Ingrese su numero de telefono',
//         buttonSumbitText: 'Pedir',
//         doubleOrderAlert: '¡Ya has presentado tu solicitud!',
//     },
//     {
//         name: "AZ",
//         code: 994,
//         minLengthTel: 5,
//         nameLabel: 'Məsələn: Muhammed',
//         namePlaceholder: 'Adınızı daxil edin',
//         phoneLabel: 'Məsələn: +994 933 543 342',
//         phonePlaceholder: 'Telefon nömrənizi daxil edin',
//         buttonSumbitText: 'Soruş',
//         doubleOrderAlert: 'Artıq müraciət etdiniz!',
//     },
//     {
//         name: "VE",
//         code: 58,
//         minLengthTel: 5,
//         nameLabel: 'Por ejemplo: Ander Sanchez',
//         namePlaceholder: 'Ingrese su nombre',
//         phoneLabel: 'Por ejemplo: +58 933 543 342',
//         phonePlaceholder: 'Ingrese su numero de telefono',
//         buttonSumbitText: 'Pedir',
//         doubleOrderAlert: '¡Ya has presentado tu solicitud!',
//     },
//     {
//         name: "TW",
//         code: 886,
//         minLengthTel: 5,
//         nameLabel: '例如：HUN',
//         namePlaceholder: '名字',
//         phoneLabel: '例如：+88612345678',
//         phonePlaceholder: '電話',
//         buttonSumbitText: '立即购买',
//         doubleOrderAlert: '你已经申请了！',
//     },
//     {
//         name: "AO",
//         code: 244,
//         minLengthTel: 5,
//         nameLabel: `EXEMPLO: MARIA BRAGA`,
//         namePlaceholder: 'Indique o seu nome',
//         phoneLabel: `EXEMPLO: +244 686754536`,
//         phonePlaceholder: 'Indique o seu número de telefone',
//         buttonSumbitText: 'Deixar um pedido',
//         doubleOrderAlert: 'Você já se inscreveu!',
//     },
//     {
//         name: "PS",
//         code: 970,
//         minLengthTel: 5,
//         nameLabel: `<label>مثال: روزامي رييس</label>`,
//         namePlaceholder: ' يرجى تقديم اسمك',
//         phoneLabel: `<label>مثال<span dir="ltr">+970 568574853</span></label>`,
//         phonePlaceholder: 'يرجى تقديم رقم هاتفك',
//         buttonSumbitText: ' أرسل الطلب الآن',
//         doubleOrderAlert: 'لقد تقدمت بالفعل!',
//     },
//     {
//         name: "ML",
//         code: 223,
//         minLengthTel: 5,
//         nameLabel: 'Par Exemple: Victor',
//         namePlaceholder: 'Nom',
//         phoneLabel: 'Par exemple: +223 77777777',
//         phonePlaceholder: 'Téléphone',
//         buttonSumbitText: 'COMMANDER',
//         doubleOrderAlert: 'Vous avez déjà postulé!',
//     },
//     {
//         name: "BJ",
//         code: 229,
//         minLengthTel: 5,
//         nameLabel: 'Par Exemple: Victor',
//         namePlaceholder: 'Nom',
//         phoneLabel: 'Par exemple: +229 77777777',
//         phonePlaceholder: 'Téléphone',
//         buttonSumbitText: 'COMMANDER',
//         doubleOrderAlert: 'Vous avez déjà postulé!',
//     },
//     {
//         name: "TJ",
//         code: 992,
//         minLengthTel: 5,
//         nameLabel: `Масалан: Иван Иванов`,
//         namePlaceholder: 'Ном',
//         phoneLabel: `Масалан: +992 54212514`,
//         phonePlaceholder: 'Телефон',
//         buttonSumbitText: 'Фармоиш',
//         doubleOrderAlert: 'Шумо аллакай муроҷиат кардаед!',
//     },
//     {
//         name: "UZ",
//         code: 998,
//         minLengthTel: 5,
//         nameLabel: 'misol: Ivan Ivanov',
//         namePlaceholder: 'Ism',
//         phoneLabel: 'misol: +998 54212514',
//         phonePlaceholder: 'telefon',
//         buttonSumbitText: 'buyurtma',
//         doubleOrderAlert: 'Siz allaqachon murojaat qildingiz!',
//     },
//     {
//         name: "LK",
//         code: 94,
//         minLengthTel: 5,
//         nameLabel: 'උදාහරණයක් ලෙස: ඇන්ඩර් සැන්චෙස්',
//         namePlaceholder: 'ඔබේ නම ඇතුලත් කරන්න',
//         phoneLabel: 'උදාහරණයක් ලෙස: +94 933 543 342',
//         phonePlaceholder: 'ඔබගේ දුරකථන අංකය ඇතුලත් කරන්න',
//         buttonSumbitText: 'නියෝගය',
//         doubleOrderAlert: 'ඔබ දැනටමත් අයදුම් කර ඇත!',
//     },
//     {
//         name: "PY",
//         code: 595,
//         minLengthTel: 5,
//         nameLabel: 'Por ejemplo: Ander Sanchez',
//         namePlaceholder: 'Ingrese su nombre',
//         phoneLabel: 'Por ejemplo: +595 933 543 342',
//         phonePlaceholder: 'Ingrese su numero de telefono',
//         buttonSumbitText: 'Pedir',
//         doubleOrderAlert: '¡Ya has presentado tu solicitud!',
//     },
//     {
//         name: "UA",
//         code: 380,
//         minLengthTel: 5,
//         nameLabel: `Наприклад: Панасюк Кіра`,
//         namePlaceholder: 'Ім\'я',
//         phoneLabel: `Наприклад: +380502689958`,
//         phonePlaceholder: 'Телефон',
//         buttonSumbitText: 'Замовивши',
//         doubleOrderAlert: 'Ви вже подали заявку!',
//     },
//     {
//         name: "RU",
//         code: 7,
//         minLengthTel: 5,
//         nameLabel: `Например: Иван Иванов`,
//         namePlaceholder: 'Имя',
//         phoneLabel: `Например: +7 54212514`,
//         phonePlaceholder: 'Телефон',
//         buttonSumbitText: 'Заказать',
//         doubleOrderAlert: 'Вы уже подали заявку!',
//     },
//     {
//         name: "KZ",
//         code: 7,
//         minLengthTel: 5,
//         nameLabel: `Например: Шаттық`,
//         namePlaceholder: 'Имя',
//         phoneLabel: `Например: +72 542 125 14`,
//         phonePlaceholder: 'Телефон',
//         buttonSumbitText: 'Заказать',
//         doubleOrderAlert: 'Вы уже подали заявку!',
//     },
//     {
//         name: "GE",
//         code: 995,
//         minLengthTel: 5,
//         nameLabel: `მაგალითად: ბარები`,
//         namePlaceholder: 'სახელი',
//         phoneLabel: `მაგალითად: +995 542 125 14`,
//         phonePlaceholder: 'ტელეფონი',
//         buttonSumbitText: 'შეკვეთა',
//         doubleOrderAlert: 'თქვენ უკვე მიმართა!',
//     },
//     {
//         name: "JP",
//         code: 81,
//         minLengthTel: 5,
//         nameLabel: '例えば: Kazuhiko Katsuo',
//         namePlaceholder: '名前',
//         phoneLabel: '例えば: +81 1520025365',
//         phonePlaceholder: '電話',
//         buttonSumbitText: '注文するには',
//         doubleOrderAlert: 'あなたはすでに適用されています！',
//     },
//     {
//         name: "PK",
//         code: 92,
//         minLengthTel: 5,
//         nameLabel: `<label>مثال: روزامي رييس</label>`,
//         namePlaceholder: ' يرجى تقديم اسمك',
//         phoneLabel: `<label>مثال<span dir="ltr">+92 568574853</span></label>`,
//         phonePlaceholder: 'يرجى تقديم رقم هاتفك',
//         buttonSumbitText: ' أرسل الطلب الآن',
//         doubleOrderAlert: 'لقد تقدمت بالفعل!',
//     },
//     {
//         name: "RW",
//         code: 250,
//         minLengthTel: 5,
//         nameLabel: 'Par Exemple: Mariette Noëlla',
//         namePlaceholder: 'Nom',
//         phoneLabel: 'Par exemple: +250 15225365',
//         phonePlaceholder: 'Numéro de téléphone',
//         buttonSumbitText: 'Commander',
//         doubleOrderAlert: 'Vous avez déjà postulé!',
//     },
//     {
//         name: "FR",
//         code: 33,
//         minLengthTel: 5,
//         nameLabel: 'Par Exemple: Mariette Noëlla',
//         namePlaceholder: 'Nom',
//         phoneLabel: 'Par exemple: +33 15225365',
//         phonePlaceholder: 'Numéro de téléphone',
//         buttonSumbitText: 'Commander',
//         doubleOrderAlert: 'Vous avez déjà postulé!',
//     },
//     {
//         name: "SN",
//         code: 221,
//         minLengthTel: 5,
//         nameLabel: 'Par Exemple: Mariette Noëlla',
//         namePlaceholder: 'Nom',
//         phoneLabel: 'Par exemple: +221 777777777',
//         phonePlaceholder: 'Numéro de téléphone',
//         buttonSumbitText: 'Commander',
//         doubleOrderAlert: 'Vous avez déjà postulé!',
//     },
//     {
//         name: "DK",
//         code: 45,
//         minLengthTel: 5,
//         nameLabel: 'For Eksempel: Cenk Aage',
//         namePlaceholder: 'Navn',
//         phoneLabel: 'For eksempel: +45 541236521',
//         phonePlaceholder: 'Telefon',
//         buttonSumbitText: 'ORDRE',
//         doubleOrderAlert: 'Du har allerede ansøgt!',
//     },
//     {
//         name: "GN",
//         code: 224,
//         minLengthTel: 5,
//         nameLabel: 'Par Exemple: Victor',
//         namePlaceholder: 'Nom',
//         phoneLabel: 'Par exemple: +224 541236521',
//         phonePlaceholder: 'Téléphone',
//         buttonSumbitText: 'COMMANDER',
//         doubleOrderAlert: 'Vous avez déjà postulé!',
//     },
//     {
//         name: "VN",
//         code: 84,
//         minLengthTel: 5,
//         nameLabel: 'Ví Dụ: Victor',
//         namePlaceholder: 'Tên',
//         phoneLabel: 'Ví dụ: +84 541236521',
//         phonePlaceholder: 'Điện thoại',
//         buttonSumbitText: 'ĐẶT HÀNG',
//         doubleOrderAlert: 'Bạn đã áp dụng!',
//     },
//     {
//         name: "CG",
//         code: 242,
//         minLengthTel: 5,
//         nameLabel: 'Par Exemple: Victor',
//         namePlaceholder: 'Nom',
//         phoneLabel: 'Par exemple: +242 541236521',
//         phonePlaceholder: 'Téléphone',
//         buttonSumbitText: 'COMMANDER',
//         doubleOrderAlert: 'Vous avez déjà postulé!',
//     },
//     {
//         name: "LV",
//         code: 371,
//         minLengthTel: 5,
//         nameLabel: `Piemēram: Alīda Vija Artmane`,
//         namePlaceholder: 'Nosaukums',
//         phoneLabel: `Piemēram: +371 933 543 342`,
//         phonePlaceholder: 'Tālrunis',
//         buttonSumbitText: 'PASŪTĪJUMS',
//         doubleOrderAlert: 'Jūs jau esat pieteicies!',
//     },
//     {
//         name: "US",
//         code: 12,
//         minLengthTel: 5,
//         nameLabel: `For example: Charlize Theron`,
//         namePlaceholder: 'Name',
//         phoneLabel: `FOR EXAMPLE: +12 933 543 342`,
//         phonePlaceholder: 'Phone',
//         buttonSumbitText: 'ORDER',
//         doubleOrderAlert: 'You have already applied!',
//     },
//     {
//         name: "CY",
//         code: 357,
//         minLengthTel: 5,
//         nameLabel: `ΓΙΑ ΠΑΡΆΔΕΙΓΜΑ: ANDRES SANCHEZ`,
//         namePlaceholder: 'Όνομα',
//         phoneLabel: `ΓΙΑ ΠΑΡΆΔΕΙΓΜΑ: +357 933 543 342`,
//         phonePlaceholder: 'Τηλέφωνο',
//         buttonSumbitText: 'ΠΑΡΑΓΓΕΛΙΑ',
//         doubleOrderAlert: 'Έχετε ήδη υποβάλει αίτηση!',
//     },
//     {
//         name: "SI",
//         code: 386,
//         minLengthTel: 5,
//         nameLabel: `NA PRIMER: MARIJA`,
//         namePlaceholder: 'Vaše Ime',
//         phoneLabel: `NA PRIMER: +386 41 679 845`,
//         phonePlaceholder: 'Vaša telefonska številka',
//         buttonSumbitText: 'Izpolnite naročilo',
//         doubleOrderAlert: 'Ste se že prijavili!',
//     },
//     {
//         name: "KH",
//         code: 855,
//         minLengthTel: 5,
//         nameLabel: `ឧទាហរណ៍: ហេងពិសិដ្ឋ`,
//         namePlaceholder: 'មោះ',
//         phoneLabel: `លេខទូរស័ព្ទ: +8551234567890`,
//         phonePlaceholder: 'ទូរស័ព្',
//         buttonSumbitText: 'បញ្ជាទិញឥឡូវនេះ',
//         doubleOrderAlert: 'អ្នកបានអនុវត្តរួចហើយ!',
//     },
//     {
//         name: "NG",
//         code: 234,
//         minLengthTel: 5,
//         nameLabel: `Example: David Adedeji Adeleke`,
//         namePlaceholder: 'Name',
//         phoneLabel: `Example: +234 123-456-7890`,
//         phonePlaceholder: 'Phone number:',
//         buttonSumbitText: 'BUY NOW!',
//         doubleOrderAlert: 'You have already applied!',
//     },
//     {
//         name: "EG",
//         code: 20,
//         minLengthTel: 5,
//         nameLabel: `<label>مثال: روزامي رييس</label>`,
//         namePlaceholder: ' يرجى تقديم اسمك',
//         phoneLabel: `<label>مثال<span dir="ltr">+20 568574853</span></label>`,
//         phonePlaceholder: 'يرجى تقديم رقم هاتفك',
//         buttonSumbitText: ' أرسل الطلب الآن',
//         doubleOrderAlert: 'لقد تقدمت بالفعل!',
//     },
//     {
//         name: "AT",
//         code: 43,
//         minLengthTel: 5,
//         nameLabel: `Zum Beispiel: Andres Sánchez`,
//         namePlaceholder: 'Name',
//         phoneLabel: `Zum Beispiel: +43 933 543 342`,
//         phonePlaceholder: 'Telefonnummer',
//         buttonSumbitText: 'BESTELLEN',
//         doubleOrderAlert: 'Sie haben sich bereits beworben!',
//     },
//     {
//         name: "SE",
//         code: 46,
//         minLengthTel: 5,
//         nameLabel: `Exempelvis: LANA BARI`,
//         namePlaceholder: 'Namn',
//         phoneLabel: `Exempelvis: +46-49-123-456`,
//         phonePlaceholder: 'Telefon',
//         buttonSumbitText: 'Beställa',
//         doubleOrderAlert: 'Du har redan ansökt!',
//     },
//     {
//         name: "HR",
//         code: 385,
//         minLengthTel: 5,
//         nameLabel: `NA PRIMJER: LANA BARIĆ`,
//         namePlaceholder: 'Ime',
//         phoneLabel: `NA PRIMJER: +385-49-123-456`,
//         phonePlaceholder: 'telefonski broj',
//         buttonSumbitText: 'Naruči odmah',
//         doubleOrderAlert: 'Već ste se prijavili!',
//     },
//     {
//         name: "ZA",
//         code: 27,
//         minLengthTel: 5,
//         nameLabel: `EXAMPLE: YUSUF AMAM`,
//         namePlaceholder: 'Your name',
//         phoneLabel: `EXAMPLE: +27 123-456-7890`,
//         phonePlaceholder: 'Phone number',
//         buttonSumbitText: 'Order now!',
//         doubleOrderAlert: 'You have already applied!',
//     },
//     {
//         name: "EE",
//         code: 372,
//         minLengthTel: 5,
//         nameLabel: 'Näiteks: Aino',
//         namePlaceholder: 'Nimi',
//         phoneLabel: `Näiteks: +372-123-123-1234`,
//         phonePlaceholder: 'Teie telefoninumber',
//         buttonSumbitText: 'Selleks',
//         doubleOrderAlert: 'Olete juba taotluse esitanud!',
//     },
//     {
//         name: "FI",
//         code: 358,
//         minLengthTel: 5,
//         nameLabel: 'Esimerkiksi: Aino',
//         namePlaceholder: 'Nimi',
//         phoneLabel: `Esimerkiksi: +358-123-123-1234`,
//         phonePlaceholder: 'Puhelinnumerosi',
//         buttonSumbitText: 'Tilata',
//         doubleOrderAlert: 'Olet jo hakenut!',
//     },
//     {
//         name: "BD",
//         code: 880,
//         minLengthTel: 5,
//         nameLabel: 'উদাহরণ: ভালো নাম`',
//         namePlaceholder: 'নাম',
//         phoneLabel: `উদাহরণ: +880-123-123-1234`,
//         phonePlaceholder: 'ফোন নাম্বার',
//         buttonSumbitText: 'আর্ডার',
//         doubleOrderAlert: 'আপনি ইতিমধ্যে আবেদন করেছেন!',
//     },
//     {
//         name: "TN",
//         code: 216,
//         minLengthTel: 5,
//         nameLabel: `<label>على سبيل المثال: محمد عطوان</label>`,
//         namePlaceholder: ' يرجى تقديم اسمك',
//         phoneLabel: `<label>مثال<span dir="ltr">+216 568574853</span></label>`,
//         phonePlaceholder: 'يرجى تقديم رقم هاتفك',
//         buttonSumbitText: ' أرسل الطلب الآن',
//         doubleOrderAlert: 'لقد تقدمت بالفعل!',
//     },
//     {
//         name: "BH",
//         code: 973,
//         minLengthTel: 5,
//         nameLabel: `<label>مثال: مراد اسعد</label>`,
//         namePlaceholder: ' يرجى تقديم اسمك',
//         phoneLabel: `<label>مثال: <bdo dir="ltr">+973555555555</bdo></label>`,
//         phonePlaceholder: 'يرجى تقديم رقم هاتفك',
//         buttonSumbitText: ' أرسل الطلب الآن',
//         doubleOrderAlert: 'لقد تقدمت بالفعل!',
//     },
//     {
//         name: "KW",
//         code: 965,
//         minLengthTel: 5,
//         nameLabel: `<label>مثال: روزامي رييس</label>`,
//         namePlaceholder: 'الاسم واللقب  / Name Surname',
//         phoneLabel: `<label for="phone2">مثال:<bdo dir="ltr">+965 568574874</bdo></label>`,
//         phonePlaceholder: 'رقم الهاتف  / Phone Number',
//         buttonSumbitText: 'ارسل الطلب',
//         doubleOrderAlert: 'لقد تقدمت بالفعل!',
//     },
//     {
//         name: "IQ",
//         code: 964,
//         minLengthTel: 5,
//         nameLabel: `<label>مثال: روزامي رييس</label>`,
//         namePlaceholder: 'الاسم واللقب  / Name Surname',
//         phoneLabel: `<label>مثال:<bdo dir="ltr">+964 568574874</bdo></label>`,
//         phonePlaceholder: 'رقم الهاتف  / Phone Number',
//         buttonSumbitText: 'ارسل الطلب',
//         doubleOrderAlert: 'لقد تقدمت بالفعل!',
//     },
//     {
//         name: "CR",
//         code: 506,
//         minLengthTel: 5,
//         nameLabel: `POR EJEMPLO: Luis Pérez`,
//         namePlaceholder: 'Tu nombre',
//         phoneLabel: `POR EJEMPLO: +506 11376265156`,
//         phonePlaceholder: 'Tu número de teléfono ',
//         buttonSumbitText: 'Pedir',
//         doubleOrderAlert: '¡Ya has presentado tu solicitud!',
//     },
//     {
//         name: "QA",
//         code: 971,
//         minLengthTel: 5,
//         nameLabel: `<label>مثال: روزامي رييس</label>`,
//         namePlaceholder: 'الاسم واللقب  / Name Surname',
//         phoneLabel: `<label>مثال: <bdo dir="ltr">+974 568574874</bdo></label>`,
//         phonePlaceholder: 'رقم الهاتف  / Phone Number',
//         buttonSumbitText: 'ارسل الطلب',
//         doubleOrderAlert: 'لقد تقدمت بالفعل!',
//     },
//     {
//         name: "PT",
//         code: 351,
//         minLengthTel: 5,
//         nameLabel: `EXEMPLO: MARIA BRAGA`,
//         namePlaceholder: 'Indique o seu nome',
//         phoneLabel: `EXEMPLO: +351 686754536`,
//         phonePlaceholder: 'Indique o seu número de telefone',
//         buttonSumbitText: 'Deixar um pedido',
//         doubleOrderAlert: 'Você já se inscreveu!',
//     },
//     {
//         name: "OM",
//         code: 968,
//         minLengthTel: 5,
//         nameLabel: `<label dir="rtl">مثال: روزامي رييس</label>`,
//         namePlaceholder: 'الاسم',
//         phoneLabel: `<label dir="rtl"> مثال: <span dir="ltr">+968 568574874</span></label>`,
//         phonePlaceholder: 'الهاتف',
//         buttonSumbitText: 'اطلب بسعر العرض',
//         doubleOrderAlert: 'لقد تقدمت بالفعل!',
//     },
//     {
//         name: "CL",
//         code: 56,
//         minLengthTel: 9,
//         nameLabel: 'POR EJEMPLO: MARÍA QUISPE',
//         namePlaceholder: 'Nombre',
//         phoneLabel: 'POR EJEMPLO: +56 13635327',
//         phonePlaceholder: 'Número de teléfono',
//         buttonSumbitText: 'Ordenar',
//         doubleOrderAlert: '¡Ya has presentado tu solicitud!',
//     },
//     {
//         name: "ID",
//         code: 62,
//         minLengthTel: 5,
//         nameLabel: 'Misalnya: TANASAL HUAN',
//         namePlaceholder: 'Nama',
//         phoneLabel: 'Misalnya: +62814555572',
//         phonePlaceholder: 'Telepon',
//         buttonSumbitText: 'Untuk memesan',
//         doubleOrderAlert: 'Anda sudah melamar!',
//     },
//     {
//         name: "KE",
//         code: 254,
//         minLengthTel: 5,
//         nameLabel: 'FOR EXAMPLE: ANDRÉS SANCHEZ',
//         namePlaceholder: 'First Name & Last Name',
//         phoneLabel: 'FOR EXAMPLE: +254 933 543 342',
//         phonePlaceholder: 'Mobile Number',
//         buttonSumbitText: 'rush my order',
//         doubleOrderAlert: 'You have already applied!',
//     },
//     {
//         name: "MK",
//         code: 389,
//         minLengthTel: 5,
//         nameLabel: 'НА ПРИМЕР: ЈОВАН ДИНЕСКИ',
//         namePlaceholder: 'Внесете го вашето име',
//         phoneLabel: 'НА ПРИМЕР: +389 71234567',
//         phonePlaceholder: 'Внесете го вашиот телефонски број',
//         buttonSumbitText: 'Нарачајте',
//         doubleOrderAlert: 'Веќе сте аплицирале!',
//     },
//     {
//         name: "ME",
//         code: 382,
//         minLengthTel: 5,
//         nameLabel: 'Na primer: Alexander Yovanovich',
//         namePlaceholder: 'Ime',
//         phoneLabel: 'Na primer: +382 98556431',
//         phonePlaceholder: 'Telefon',
//         buttonSumbitText: 'Për të porositur',
//         doubleOrderAlert: 'Ju keni aplikuar tashmë!',
//     },
//     {
//         name: "XK",
//         code: 383,
//         minLengthTel: 5,
//         nameLabel: 'Na primer: Alexander Yovanovich',
//         namePlaceholder: 'Ime',
//         phoneLabel: 'Na primer: +383 98556431',
//         phonePlaceholder: 'Telefon',
//         buttonSumbitText: 'Për të porositur',
//         doubleOrderAlert: 'Ju keni aplikuar tashmë!',
//     },
//     {
//         name: "AL",
//         code: 355,
//         minLengthTel: 5,
//         nameLabel: 'SHEMBULL: KLEVIS ROBO',
//         namePlaceholder: 'Emër',
//         phoneLabel: 'SHEMBULL: +355 123456789',
//         phonePlaceholder: 'Telefon',
//         buttonSumbitText: 'Naruči odmah',
//         doubleOrderAlert: 'Ju keni aplikuar tashmë!',
//     },
//     {
//         name: "MY",
//         code: 60,
//         minLengthTel: 5,
//         nameLabel: 'Misalnya: PERRY SOEHARTO',
//         namePlaceholder: 'Nama',
//         phoneLabel: 'Misalnya: +607871234567',
//         phonePlaceholder: 'Telepon',
//         buttonSumbitText: 'Untuk memesan',
//         doubleOrderAlert: 'Anda sudah melamar!',
//     },
//     {
//         name: "BG",
//         code: 359,
//         minLengthTel: 5,
//         nameLabel: 'НАПРИМЕР: СТОЯН СТОЯНОВ',
//         namePlaceholder: 'Въведете име',
//         phoneLabel: 'НАПРИМЕР: +359 777555888',
//         phonePlaceholder: 'Въведете телефонен номер',
//         buttonSumbitText: 'Поръчай',
//         doubleOrderAlert: 'Вече сте кандидатствали!',
//     },
//     {
//         name: "CO",
//         code: 57,
//         minLengthTel: 10,
//         nameLabel: 'EJEMPLO: LAURA LÓPEZ',
//         namePlaceholder: 'Nombre y Apellido',
//         phoneLabel: 'EJEMPLO: +57 1414270412',
//         phonePlaceholder: 'Teléfono',
//         buttonSumbitText: 'Pedir',
//         doubleOrderAlert: '¡Ya has presentado tu solicitud!',
//     },
//     {
//         name: "EC",
//         code: 593,
//         minLengthTel: 9,
//         nameLabel: 'POR EJEMPLO: MARÍA LOPEZ',
//         namePlaceholder: 'Alejandro Rodriguez',
//         phoneLabel: 'POR EJEMPLO: +593 933 543 342',
//         phonePlaceholder: 'Ingrese su teléfono',
//         buttonSumbitText: 'DEJAR UNA SOLICITUD',
//         doubleOrderAlert: '¡Ya has presentado tu solicitud!',
//     },
//     {
//         name: "ES",
//         code: 34,
//         minLengthTel: 9,
//         nameLabel: 'Por ejemplo: Ander Sanchez',
//         namePlaceholder: 'Ingrese su nombre',
//         phoneLabel: 'Por ejemplo: +34 933 543 342',
//         phonePlaceholder: 'Ingrese su numero de telefono',
//         buttonSumbitText: 'Pedir',
//         doubleOrderAlert: '¡Ya has presentado tu solicitud!',
//     },
//     {
//         name: "GR",
//         code: 30,
//         minLengthTel: 10,
//         nameLabel: 'ΓΙΑ ΠΑΡΆΔΕΙΓΜΑ: ANDRES SANCHEZ',
//         namePlaceholder: 'Όνομα',
//         phoneLabel: 'ΓΙΑ ΠΑΡΆΔΕΙΓΜΑ: +30 933 543 342',
//         phonePlaceholder: 'Τηλέφωνο',
//         buttonSumbitText: 'Παραγγείλτε με',
//         doubleOrderAlert: 'Έχετε ήδη υποβάλει αίτηση!',
//     },
//     {
//         name: "GT",
//         code: 502,
//         minLengthTel: 8,
//         nameLabel: 'Ejemplo: Jorge García',
//         namePlaceholder: 'Nombre',
//         phoneLabel: 'Ejemplo: +502 5552502471',
//         phonePlaceholder: 'Teléfono',
//         buttonSumbitText: 'Pedir',
//         doubleOrderAlert: '¡Ya has presentado tu solicitud!',
//     },
//     {
//         name: "IT",
//         code: 39,
//         minLengthTel: 10,
//         nameLabel: 'PER ESEMPIO: MARIA BIANCHI',
//         namePlaceholder: 'Nome',
//         phoneLabel: 'PER ESEMPIO: +39213457680',
//         phonePlaceholder: 'Telefono',
//         buttonSumbitText: 'Compra',
//         doubleOrderAlert: 'Hai già fatto domanda!',
//     },
//     {
//         name: "MA",
//         code: 212,
//         minLengthTel: 9,
//         nameLabel: `<label dir="rtl"> مثال: مراد اسعد</label>`,
//         namePlaceholder: 'اسمك',
//         phoneLabel: `<label dir="rtl"> مثال: <span dir="ltr">+212 0000000</span></label>`,
//         phonePlaceholder: 'رقم هاتفك',
//         buttonSumbitText: 'اطلب بخصم',
//         doubleOrderAlert: 'لقد تقدمت بالفعل!',
//     },
//     {
//         name: "MX",
//         code: 52,
//         minLengthTel: 10,
//         nameLabel: 'POR EJEMPLO: ANDER SANCHEZ',
//         namePlaceholder: 'Su nombre',
//         phoneLabel: 'POR EJEMPLO: +52 933 543 342',
//         phonePlaceholder: 'Ingrese su numero de telefono',
//         buttonSumbitText: 'Pedir',
//         doubleOrderAlert: '¡Ya has presentado tu solicitud!',
//     },
//     {
//         name: "PA",
//         code: 507,
//         minLengthTel: 8,
//         nameLabel: 'EJEMPLO: ALEJANDRA PÉREZ',
//         namePlaceholder: 'Nombre',
//         phoneLabel: 'EJEMPLO: +507 12345678',
//         phonePlaceholder: 'Número',
//         buttonSumbitText: 'Realizar pedido',
//         doubleOrderAlert: '¡Ya has presentado tu solicitud!',
//     },
//     {
//         name: "PE",
//         code: 51,
//         minLengthTel: 9,
//         nameLabel: 'POR EJEMPLO: MARÍA GARCÍA',
//         namePlaceholder: 'Nombre',
//         phoneLabel: 'POR EJEMPLO: +51 983 438 848',
//         phonePlaceholder: 'Número de teléfono',
//         buttonSumbitText: 'Ordena',
//         doubleOrderAlert: '¡Ya has presentado tu solicitud!',
//     },
//     {
//         name: "PL",
//         code: 48,
//         minLengthTel: 9,
//         nameLabel: 'NA PRZYKŁAD: JAN KOWALSKI',
//         namePlaceholder: 'Imię i nazwisko',
//         phoneLabel: 'NA PRZYKŁAD: +48780185369',
//         phonePlaceholder: 'Numer',
//         buttonSumbitText: 'Zamówić',
//         doubleOrderAlert: 'Już złożyłeś wniosek!',
//     },
//     {
//         name: "TH",
//         code: 66,
//         minLengthTel: 5,
//         nameLabel: 'ตัวอย่าง: โทนี่จา',
//         namePlaceholder: 'ระบุชื่อ - นามสกุล',
//         phoneLabel: 'ตัวอย่าง: +66(038)234567',
//         phonePlaceholder: 'ระบุเบอร์โทรศัพท์',
//         buttonSumbitText: 'สั่งซื้อตอนนี้',
//         doubleOrderAlert: 'คุณได้สมัครแล้ว!',
//     },
//     {
//         name: "RO",
//         code: 40,
//         minLengthTel: 9,
//         nameLabel: 'De exemplu: Ion Petrescu:',
//         namePlaceholder: 'Declarați numele dvs.',
//         phoneLabel: 'De exemplu: +40 989009736:',
//         phonePlaceholder: 'Introduceți numărul dvs. de telefon',
//         buttonSumbitText: 'Comandă',
//         doubleOrderAlert: 'Ați aplicat deja!',
//     },
//     {
//         name: "AR",
//         code: 54,
//         minLengthTel: 10,
//         nameLabel: 'EJEMPLO: LAURA LÓPEZ',
//         namePlaceholder: 'Nombre y Apellido*',
//         phoneLabel: 'EJEMPLO: +54 1414270412',
//         phonePlaceholder: 'Teléfono*',
//         buttonSumbitText: 'Pedir',
//         doubleOrderAlert: '¡Ya has presentado tu solicitud!',
//     },
//     {
//         name: "TR",
//         code: 90,
//         minLengthTel: 5,
//         nameLabel: 'ÖRNEK: Burak Özçivit',
//         namePlaceholder: 'Ad ve soyad',
//         phoneLabel: 'ÖRNEK: +90 11 2910008',
//         phonePlaceholder: 'Telefon numarası',
//         buttonSumbitText: 'Göndermek',
//         doubleOrderAlert: 'Zaten başvurdunuz!',
//     },
//     {
//         name: "SK",
//         code: 421,
//         minLengthTel: 5,
//         nameLabel: 'NAPŘÍKLAD: IVAN KAŠPAR',
//         namePlaceholder: 'Moje meno',
//         phoneLabel: 'NAPŘÍKLAD: +42143456726',
//         phonePlaceholder: 'Môj telefón',
//         buttonSumbitText: 'Objednávajte',
//         doubleOrderAlert: 'Už ste sa prihlásili!',
//     },
//     {
//         name: "HU",
//         code: 36,
//         minLengthTel: 5,
//         nameLabel: 'PÉLDÁUL: KÁLMÁN DÁNIEL',
//         namePlaceholder: 'Ime',
//         phoneLabel: 'PÉLDÁUL: +36 1111 11111',
//         phonePlaceholder: 'Telefonszám',
//         buttonSumbitText: 'MEGRENDELÉS',
//         doubleOrderAlert: 'Ön már jelentkezett!',
//     },
//     {
//         name: "CZ",
//         code: 420,
//         minLengthTel: 5,
//         nameLabel: 'Například: Lukáš Aragonský',
//         namePlaceholder: 'Vaše jméno ',
//         phoneLabel: 'Například: +420 777888555',
//         phonePlaceholder: 'Zadejte telefonní číslo ',
//         buttonSumbitText: 'Poslat',
//         doubleOrderAlert: 'Už jste podali přihlášku!',
//     },
//     {
//         name: "SA",
//         code: 966,
//         minLengthTel: 5,
//         nameLabel: '<label>مثال: روزامي رييس</label>',
//         namePlaceholder: 'اسمك',
//         phoneLabel: '<label> مثال:<bdo dir="ltr">+966 568574874</bdo></label>',
//         phonePlaceholder: 'رقم تليفونك',
//         buttonSumbitText: 'اطلب ',
//         doubleOrderAlert: 'لقد تقدمت بالفعل!',
//     },
//     {
//         name: "LB",
//         code: 961,
//         minLengthTel: 5,
//         nameLabel: '<label>مثال: روزامي رييس</label>',
//         namePlaceholder: 'اسمك',
//         phoneLabel: '<label> مثال:<bdo dir="ltr">+961 568574874</bdo></label>',
//         phonePlaceholder: 'رقم تليفونك',
//         buttonSumbitText: 'اطلب ',
//         doubleOrderAlert: 'لقد تقدمت بالفعل!',
//     },
//     {
//         name: "BA",
//         code: 387,
//         minLengthTel: 5,
//         nameLabel: 'Primjer: Miljan Prljeta',
//         namePlaceholder: 'Tvoje ime',
//         phoneLabel: 'Primjer: +387 11 2910008',
//         phonePlaceholder: 'Tvoj broj telefona',
//         buttonSumbitText: 'Naruči',
//         doubleOrderAlert: 'Već ste se prijavili!',
//     },
//     {
//         name: "RS",
//         code: 381,
//         minLengthTel: 5,
//         nameLabel: 'Na primjer: Ivan Stankovich',
//         namePlaceholder: 'Unesite vaše ime',
//         phoneLabel: 'Na primjer: +38124876456',
//         phonePlaceholder: 'Unesite vaš broj telefona',
//         buttonSumbitText: 'Naruči',
//         doubleOrderAlert: 'Već ste se prijavili!',
//     },
//     {
//         name: "LY",
//         code: 218,
//         minLengthTel: 5,
//         nameLabel: '<label>مثال: روزامي رييس</label>',
//         namePlaceholder: 'اسمك',
//         phoneLabel: '<label> مثال:<bdo dir="ltr">+218 568574874</bdo></label>',
//         phonePlaceholder: 'رقم تليفونك',
//         buttonSumbitText: 'اطلب',
//         doubleOrderAlert: 'لقد تقدمت بالفعل!',
//     },
//     {
//         name: "AE",
//         code: 971,
//         minLengthTel: 5,
//         nameLabel: '<label>مثال: روزامي رييس</label>',
//         namePlaceholder: 'الاسم واللقب  / Name Surname',
//         phoneLabel: '<label> مثال:<bdo dir="ltr">+971 568574874</bdo></label>',
//         phonePlaceholder: 'رقم الهاتف  / Phone Number',
//         buttonSumbitText: 'يشترى',
//         doubleOrderAlert: 'لقد تقدمت بالفعل!',
//     },
//     {
//         name: "SG",
//         code: 65,
//         minLengthTel: 5,
//         nameLabel: '例如：HUN',
//         namePlaceholder: '名字',
//         phoneLabel: '例如：+6512345678',
//         phonePlaceholder: '電話',
//         buttonSumbitText: '立即购买',
//         doubleOrderAlert: '你已经申请了！',
//     },
//     {
//         name: "CI",
//         code: 225,
//         minLengthTel: 5,
//         nameLabel: 'Par Exemple: Victor',
//         namePlaceholder: 'Nom',
//         phoneLabel: 'Par exemple: +225 541236521',
//         phonePlaceholder: 'Téléphone',
//         buttonSumbitText: 'COMMANDER',
//         doubleOrderAlert: 'Vous avez déjà postulé!',
//     },
//     {
//         name: "DZ",
//         code: 213,
//         minLengthTel: 5,
//         nameLabel: '<label dir="rtl">على سبيل المثال: محمد عطوان</label>',
//         namePlaceholder: 'الاسم الاول',
//         phoneLabel: '<label> مثا<span dir="ltr" style="direction: ltr">+213 568574853</span></label>',
//         phonePlaceholder: 'رقم الهاتف',
//         buttonSumbitText: 'زر الشراء',
//         doubleOrderAlert: 'لقد تقدمت بالفعل!',
//     },
//     {
//         name: "LT",
//         code: 370,
//         minLengthTel: 5,
//         nameLabel: 'Kaip antai: SOFIA YURIMAA',
//         namePlaceholder: 'Vardas',
//         phoneLabel: 'Kaip antai: +370 12345678',
//         phonePlaceholder: 'Telefonas',
//         buttonSumbitText: 'Užsakyti',
//         doubleOrderAlert: 'Jūs jau pateikėte paraišką!',
//     },
//     {
//         name: "PH",
//         code: 63,
//         minLengthTel: 5,
//         nameLabel: 'HALIMBAWA: ANDER SANCHEZ',
//         namePlaceholder: 'Pangalan at Apelyido',
//         phoneLabel: 'HALIMBAWA: +63 933 543 342',
//         phonePlaceholder: 'Numero ng Mobile',
//         buttonSumbitText: 'order na',
//         doubleOrderAlert: 'Nag-apply ka na!',
//     },
//     {
//         name: "BE",
//         code: 32,
//         minLengthTel: 5,
//         nameLabel: 'Par Exemple: Victor',
//         namePlaceholder: 'Nom et prénom',
//         phoneLabel: 'Par exemple: +32 541 236 521',
//         phonePlaceholder: 'téléphone fixe',
//         buttonSumbitText: 'COMMANDEZ',
//         doubleOrderAlert: 'Vous avez déjà postulé!',
//     },
//     {
//         name: "DE",
//         code: 49,
//         minLengthTel: 5,
//         nameLabel: 'Zum Beispiel: Andres Sánchez',
//         namePlaceholder: 'Name',
//         phoneLabel: 'Zum Beispiel: +49 933 543 342',
//         phonePlaceholder: 'Telefonnummer',
//         buttonSumbitText: 'Jetzt',
//         doubleOrderAlert: 'Sie haben sich bereits beworben!',
//     },
//     {
//         name: "IN",
//         code: 91,
//         minLengthTel: 5,
//         nameLabel: 'उदाहरण के लिए: एमीलिया',
//         namePlaceholder: 'आपका नाम',
//         phoneLabel: 'उदाहरण के लिए: +91 11 43638201',
//         phonePlaceholder: 'आपका फ़ोन नंबर',
//         buttonSumbitText: 'अभी ऑर्डर करें',
//         doubleOrderAlert: 'तुम्ही आधीच अर्ज केला आहे!',
//     },
//     {
//         name: "JO",
//         code: 962,
//         minLengthTel: 5,
//         nameLabel: '<label>مثال: روزامي رييس</label>',
//         namePlaceholder: 'اسمك',
//         phoneLabel: '<label> مثال:<bdo dir="ltr">+962 568574874</bdo></label>',
//         phonePlaceholder: 'هاتفك',
//         buttonSumbitText: 'زر الشراء',
//         doubleOrderAlert: 'لقد تقدمت بالفعل!',
//     },
//     {
//         name: "CH",
//         code: 41,
//         minLengthTel: 5,
//         nameLabel: 'Zum Beispiel: Wilhelm Stolz',
//         namePlaceholder: 'Ihr Name',
//         phoneLabel: 'Zum Beispiel: +41 548521478',
//         phonePlaceholder: 'Ihre Telefonnummer',
//         buttonSumbitText: 'Bestellen',
//         doubleOrderAlert: 'Sie haben sich bereits beworben!',
//     },
//     {
//         name: "BO",
//         code: 591,
//         minLengthTel: 5,
//         nameLabel: 'POR EJEMPLO: JUAN GARCÍA',
//         namePlaceholder: 'Tu nombre',
//         phoneLabel: 'POR EJEMPLO: +591 13635321',
//         phonePlaceholder: 'Tu número de teléfono',
//         buttonSumbitText: '¡Comprar con descuento!',
//         doubleOrderAlert: '¡Ya has presentado tu solicitud!',
//     },
// ];

export const countryData1 = [
    {
        name: "GH",
        code: 233,
        minLengthTel: 5,
        nameLabel: "FOR EXAMPLE: Kwame Mensah",
        namePlaceholder: "First Name & Last Name",
        phoneLabel: "FOR EXAMPLE: +233 933 543 342",
        phonePlaceholder: "Mobile Number",
        buttonSumbitText: "rush my order",
        doubleOrderAlert: "You have already applied!",
    },
    {
        name: "UG",
        code: 256,
        minLengthTel: 5,
        nameLabel: "FOR EXAMPLE: John Okello",
        namePlaceholder: "First Name & Last Name",
        phoneLabel: "FOR EXAMPLE: +256 933 543 342",
        phonePlaceholder: "Mobile Number",
        buttonSumbitText: "rush my order",
        doubleOrderAlert: "You have already applied!",
    },
    {
        name: "AM",
        code: 374,
        minLengthTel: 5,
        nameLabel: "Օրինակ՝ Արամ Սարգսյան",
        namePlaceholder: "Ձեր անունը",
        phoneLabel: "Օրինակ: +374 93 54 344",
        phonePlaceholder: "Մուտքագրեք հեռախոսը",
        buttonSumbitText: "Պատվիրել",
        doubleOrderAlert: "Դուք արդեն դիմել եք:",
    },
    {
        name: "DO",
        code: 1809,
        minLengthTel: 5,
        nameLabel: "POR EJEMPLO: Juan Rodríguez",
        namePlaceholder: "Su nombre",
        phoneLabel: "POR EJEMPLO: +1809 933 543 342",
        phonePlaceholder: "Ingrese su numero de telefono",
        buttonSumbitText: "Pedir",
        doubleOrderAlert: "¡Ya has presentado tu solicitud!",
    },
    {
        name: "TZ",
        code: 255,
        minLengthTel: 5,
        nameLabel: "FOR EXAMPLE: Asha Mwinyi",
        namePlaceholder: "First Name & Last Name",
        phoneLabel: "FOR EXAMPLE: +255 933 543 342",
        phonePlaceholder: "Mobile Number",
        buttonSumbitText: "rush my order",
        doubleOrderAlert: "You have already applied!",
    },
    {
        name: "SV",
        code: 503,
        minLengthTel: 5,
        nameLabel: "POR EJEMPLO: José Martínez",
        namePlaceholder: "Su nombre",
        phoneLabel: "POR EJEMPLO: +503 933 543 342",
        phonePlaceholder: "Ingrese su numero de telefono",
        buttonSumbitText: "Pedir",
        doubleOrderAlert: "¡Ya has presentado tu solicitud!",
    },
    {
        name: "HN",
        code: 504,
        minLengthTel: 5,
        nameLabel: "POR EJEMPLO: Carlos Hernández",
        namePlaceholder: "Su nombre",
        phoneLabel: "POR EJEMPLO: +504 933 543 342",
        phonePlaceholder: "Ingrese su numero de telefono",
        buttonSumbitText: "Pedir",
        doubleOrderAlert: "¡Ya has presentado tu solicitud!",
    },
    {
        name: "AZ",
        code: 994,
        minLengthTel: 5,
        nameLabel: "Məsələn: Elvin Məmmədov",
        namePlaceholder: "Adınızı daxil edin",
        phoneLabel: "Məsələn: +994 933 543 342",
        phonePlaceholder: "Telefon nömrənizi daxil edin",
        buttonSumbitText: "Soruş",
        doubleOrderAlert: "Artıq müraciət etdiniz!",
    },
    {
        name: "VE",
        code: 58,
        minLengthTel: 5,
        nameLabel: "Por ejemplo: María González",
        namePlaceholder: "Ingrese su nombre",
        phoneLabel: "Por ejemplo: +58 933 543 342",
        phonePlaceholder: "Ingrese su numero de telefono",
        buttonSumbitText: "Pedir",
        doubleOrderAlert: "¡Ya has presentado tu solicitud!",
    },
    {
        name: "TW",
        code: 886,
        minLengthTel: 5,
        nameLabel: "例如：陳偉",
        namePlaceholder: "名字",
        phoneLabel: "例如：+88612345678",
        phonePlaceholder: "電話",
        buttonSumbitText: "立即购买",
        doubleOrderAlert: "你已经申请了！",
    },
    {
        name: "AO",
        code: 244,
        minLengthTel: 5,
        nameLabel: "POR EXEMPLO: Manuel Silva",
        namePlaceholder: "Seu nome",
        phoneLabel: "POR EXEMPLO: +244 933 543 342",
        phonePlaceholder: "Número de telefone",
        buttonSumbitText: "Encomendar",
        doubleOrderAlert: "Você já fez o pedido!",
    },
    {
        name: "ML",
        code: 223,
        minLengthTel: 5,
        nameLabel: "PAR EXEMPLE: Mamadou Traoré",
        namePlaceholder: "Votre nom",
        phoneLabel: "PAR EXEMPLE: +223 933 543 342",
        phonePlaceholder: "Numéro de téléphone",
        buttonSumbitText: "Commander",
        doubleOrderAlert: "Vous avez déjà postulé!",
    },
    {
        name: "CI",
        code: 225,
        minLengthTel: 5,
        nameLabel: "PAR EXEMPLE: Kouadio Koné",
        namePlaceholder: "Votre nom",
        phoneLabel: "PAR EXEMPLE: +225 933 543 342",
        phonePlaceholder: "Numéro de téléphone",
        buttonSumbitText: "Commander",
        doubleOrderAlert: "Vous avez déjà postulé!",
    },
    {
        name: "SN",
        code: 221,
        minLengthTel: 5,
        nameLabel: "PAR EXEMPLE: Cheikh Ndiaye",
        namePlaceholder: "Votre nom",
        phoneLabel: "PAR EXEMPLE: +221 933 543 342",
        phonePlaceholder: "Numéro de téléphone",
        buttonSumbitText: "Commander",
        doubleOrderAlert: "Vous avez déjà postulé!",
    },
    {
        name: "NG",
        code: 234,
        minLengthTel: 5,
        nameLabel: "FOR EXAMPLE: Chinedu Okafor",
        namePlaceholder: "First Name & Last Name",
        phoneLabel: "FOR EXAMPLE: +234 933 543 342",
        phonePlaceholder: "Mobile Number",
        buttonSumbitText: "rush my order",
        doubleOrderAlert: "You have already applied!",
    },
    {
        name: "KE",
        code: 254,
        minLengthTel: 5,
        nameLabel: "FOR EXAMPLE: Peter Njoroge",
        namePlaceholder: "First Name & Last Name",
        phoneLabel: "FOR EXAMPLE: +254 933 543 342",
        phonePlaceholder: "Mobile Number",
        buttonSumbitText: "rush my order",
        doubleOrderAlert: "You have already applied!",
    },
    {
        name: "ZA",
        code: 27,
        minLengthTel: 5,
        nameLabel: "FOR EXAMPLE: Thabo Mokoena",
        namePlaceholder: "First Name & Last Name",
        phoneLabel: "FOR EXAMPLE: +27 933 543 342",
        phonePlaceholder: "Mobile Number",
        buttonSumbitText: "rush my order",
        doubleOrderAlert: "You have already applied!",
    },
    {
        name: "BJ",
        code: 229,
        minLengthTel: 5,
        nameLabel: "Par Exemple: Augustin Houngbédji",
        namePlaceholder: "Nom",
        phoneLabel: "Par exemple: +229 77777777",
        phonePlaceholder: "Téléphone",
        buttonSumbitText: "COMMANDER",
        doubleOrderAlert: "Vous avez déjà postulé!",
    },
    {
        name: "TJ",
        code: 992,
        minLengthTel: 5,
        nameLabel: "Масалан: Фирдавс Саидов",
        namePlaceholder: "Ном",
        phoneLabel: "Масалан: +992 54212514",
        phonePlaceholder: "Телефон",
        buttonSumbitText: "Фармоиш",
        doubleOrderAlert: "Шумо аллакай муроҷиат кардаед!",
    },
    {
        name: "UZ",
        code: 998,
        minLengthTel: 5,
        nameLabel: "Misol: Azizbek Karimov",
        namePlaceholder: "Ism",
        phoneLabel: "Misol: +998 54212514",
        phonePlaceholder: "Telefon",
        buttonSumbitText: "Buyurtma",
        doubleOrderAlert: "Siz allaqachon murojaat qildingiz!",
    },
    {
        name: "LK",
        code: 94,
        minLengthTel: 5,
        nameLabel: "උදාහරණයක් ලෙස: සචින් පෙරේරා",
        namePlaceholder: "ඔබේ නම ඇතුලත් කරන්න",
        phoneLabel: "උදාහරණයක් ලෙස: +94 933 543 342",
        phonePlaceholder: "ඔබගේ දුරකථන අංකය ඇතුලත් කරන්න",
        buttonSumbitText: "නියෝගය",
        doubleOrderAlert: "ඔබ දැනටමත් අයදුම් කර ඇත!",
    },
    {
        name: "PY",
        code: 595,
        minLengthTel: 5,
        nameLabel: "Por ejemplo: Juan Benítez",
        namePlaceholder: "Ingrese su nombre",
        phoneLabel: "Por ejemplo: +595 933 543 342",
        phonePlaceholder: "Ingrese su numero de telefono",
        buttonSumbitText: "Pedir",
        doubleOrderAlert: "¡Ya has presentado tu solicitud!",
    },
    {
        name: "UA",
        code: 380,
        minLengthTel: 5,
        nameLabel: "Наприклад: Олена Шевченко",
        namePlaceholder: "Ім'я",
        phoneLabel: "Наприклад: +380502689958",
        phonePlaceholder: "Телефон",
        buttonSumbitText: "Замовити",
        doubleOrderAlert: "Ви вже подали заявку!",
    },
    {
        name: "RU",
        code: 7,
        minLengthTel: 5,
        nameLabel: "Например: Иван Петров",
        namePlaceholder: "Имя",
        phoneLabel: "Например: +7 54212514",
        phonePlaceholder: "Телефон",
        buttonSumbitText: "Заказать",
        doubleOrderAlert: "Вы уже подали заявку!",
    },
    {
        name: "GE",
        code: 995,
        minLengthTel: 5,
        nameLabel: "მაგალითად: ნინო ბერიძე",
        namePlaceholder: "სახელი",
        phoneLabel: "მაგალითად: +995 542 125 14",
        phonePlaceholder: "ტელეფონი",
        buttonSumbitText: "შეკვეთა",
        doubleOrderAlert: "თქვენ უკვე მიმართეთ!",
    },
    {
        name: "JP",
        code: 81,
        minLengthTel: 5,
        nameLabel: "例えば: 山田 太郎",
        namePlaceholder: "名前",
        phoneLabel: "例えば: +81 1520025365",
        phonePlaceholder: "電話",
        buttonSumbitText: "注文する",
        doubleOrderAlert: "あなたはすでに申し込み済みです！",
    },
    {
        name: "RW",
        code: 250,
        minLengthTel: 5,
        nameLabel: "Urugero: Jean Uwimana",
        namePlaceholder: "Izina",
        phoneLabel: "Urugero: +250 788123456",
        phonePlaceholder: "Telefoni",
        buttonSumbitText: "Tega Itegeko",
        doubleOrderAlert: "Wasabye kera!",
    },
    {
        name: "CO",
        code: 57,
        minLengthTel: 10,
        nameLabel: "Por ejemplo: Andrés Gómez",
        namePlaceholder: "Nombre",
        phoneLabel: "Por ejemplo: +57 3101234567",
        phonePlaceholder: "Teléfono",
        buttonSumbitText: "Ordenar",
        doubleOrderAlert: "¡Ya has realizado una solicitud!",
    },
    {
        name: "PE",
        code: 51,
        minLengthTel: 9,
        nameLabel: "Por ejemplo: María Quispe",
        namePlaceholder: "Nombre",
        phoneLabel: "Por ejemplo: +51 987654321",
        phonePlaceholder: "Teléfono",
        buttonSumbitText: "Ordenar",
        doubleOrderAlert: "¡Ya enviaste una solicitud!",
    },
    {
        name: "CL",
        code: 56,
        minLengthTel: 9,
        nameLabel: "Por ejemplo: Sebastián Rojas",
        namePlaceholder: "Nombre",
        phoneLabel: "Por ejemplo: +56 912345678",
        phonePlaceholder: "Teléfono",
        buttonSumbitText: "Ordenar",
        doubleOrderAlert: "¡Ya enviaste una solicitud!",
    },
    {
        name: "EC",
        code: 593,
        minLengthTel: 9,
        nameLabel: "Por ejemplo: Luis Sánchez",
        namePlaceholder: "Nombre",
        phoneLabel: "Por ejemplo: +593 998765432",
        phonePlaceholder: "Teléfono",
        buttonSumbitText: "Ordenar",
        doubleOrderAlert: "¡Ya has enviado tu solicitud!",
    },
    {
        name: "MX",
        code: 52,
        minLengthTel: 10,
        nameLabel: "Por ejemplo: José Ramírez",
        namePlaceholder: "Nombre",
        phoneLabel: "Por ejemplo: +52 5512345678",
        phonePlaceholder: "Teléfono",
        buttonSumbitText: "Ordenar",
        doubleOrderAlert: "¡Ya has hecho una solicitud!",
    },
    {
        name: "CR",
        code: 506,
        minLengthTel: 5,
        nameLabel: "Por ejemplo: Daniela Morales",
        namePlaceholder: "Nombre",
        phoneLabel: "Por ejemplo: +506 88881234",
        phonePlaceholder: "Teléfono",
        buttonSumbitText: "Ordenar",
        doubleOrderAlert: "¡Ya enviaste una solicitud!",
    },
    {
        name: "PA",
        code: 507,
        minLengthTel: 8,
        nameLabel: "Por ejemplo: Ricardo González",
        namePlaceholder: "Nombre",
        phoneLabel: "Por ejemplo: +507 61234567",
        phonePlaceholder: "Teléfono",
        buttonSumbitText: "Ordenar",
        doubleOrderAlert: "¡Ya enviaste tu solicitud!",
    },
    {
        name: "BO",
        code: 591,
        minLengthTel: 5,
        nameLabel: "Por ejemplo: Carla Fernández",
        namePlaceholder: "Nombre",
        phoneLabel: "Por ejemplo: +591 71234567",
        phonePlaceholder: "Teléfono",
        buttonSumbitText: "Ordenar",
        doubleOrderAlert: "¡Ya realizaste una solicitud!",
    },
    {
        name: "DK",
        code: 45,
        minLengthTel: 5,
        nameLabel: "For eksempel: Anders Jensen",
        namePlaceholder: "Navn",
        phoneLabel: "For eksempel: +45 12345678",
        phonePlaceholder: "Telefon",
        buttonSumbitText: "Bestil",
        doubleOrderAlert: "Du har allerede ansøgt!",
    },
    {
        name: "GT",
        code: 502,
        minLengthTel: 8,
        nameLabel: "Por ejemplo: Alejandro López",
        namePlaceholder: "Nombre",
        phoneLabel: "Por ejemplo: +502 51234567",
        phonePlaceholder: "Teléfono",
        buttonSumbitText: "Ordenar",
        doubleOrderAlert: "¡Ya enviaste una solicitud!",
    },
    {
        name: "AR",
        code: 54,
        minLengthTel: 10,
        nameLabel: "Por ejemplo: Martín González",
        namePlaceholder: "Nombre",
        phoneLabel: "Por ejemplo: +54 91123456789",
        phonePlaceholder: "Teléfono",
        buttonSumbitText: "Ordenar",
        doubleOrderAlert: "¡Ya has enviado una solicitud!",
    },
    {
        name: "TR",
        code: 90,
        minLengthTel: 5,
        nameLabel: "Örneğin: Mehmet Yılmaz",
        namePlaceholder: "Ad",
        phoneLabel: "Örneğin: +90 5312345678",
        phonePlaceholder: "Telefon",
        buttonSumbitText: "Sipariş Ver",
        doubleOrderAlert: "Zaten başvurdunuz!",
    },
    {
        name: "ID",
        code: 62,
        minLengthTel: 5,
        nameLabel: "Contoh: Budi Santoso",
        namePlaceholder: "Nama",
        phoneLabel: "Contoh: +62 81234567890",
        phonePlaceholder: "Telepon",
        buttonSumbitText: "Pesan",
        doubleOrderAlert: "Anda sudah mengajukan permintaan!",
    },
    {
        name: "PH",
        code: 63,
        minLengthTel: 5,
        nameLabel: "For example: Maria Santos",
        namePlaceholder: "Name",
        phoneLabel: "For example: +63 9123456789",
        phonePlaceholder: "Phone",
        buttonSumbitText: "Order",
        doubleOrderAlert: "You have already applied!",
    },
    {
        name: "TH",
        code: 66,
        minLengthTel: 5,
        nameLabel: "ตัวอย่าง: สมชาย สุขใจ",
        namePlaceholder: "ชื่อ",
        phoneLabel: "ตัวอย่าง: +66 812345678",
        phonePlaceholder: "โทรศัพท์",
        buttonSumbitText: "สั่งซื้อ",
        doubleOrderAlert: "คุณได้สมัครแล้ว!",
    },
    {
        name: "VN",
        code: 84,
        minLengthTel: 5,
        nameLabel: "Ví dụ: Nguyễn Văn An",
        namePlaceholder: "Tên",
        phoneLabel: "Ví dụ: +84 912345678",
        phonePlaceholder: "Điện thoại",
        buttonSumbitText: "Đặt hàng",
        doubleOrderAlert: "Bạn đã đăng ký rồi!",
    },
    {
        name: "MY",
        code: 60,
        minLengthTel: 5,
        nameLabel: "Contoh: Ahmad Zulkifli",
        namePlaceholder: "Nama",
        phoneLabel: "Contoh: +60 123456789",
        phonePlaceholder: "Telefon",
        buttonSumbitText: "Pesan",
        doubleOrderAlert: "Anda sudah membuat permintaan!",
    },
    {
        name: "SG",
        code: 65,
        minLengthTel: 5,
        nameLabel: "For example: John Tan",
        namePlaceholder: "Name",
        phoneLabel: "For example: +65 91234567",
        phonePlaceholder: "Phone",
        buttonSumbitText: "Order",
        doubleOrderAlert: "You have already applied!",
    },
    {
        name: "KH",
        code: 855,
        minLengthTel: 5,
        nameLabel: "ឧទាហរណ៍: សុខ វិសាល",
        namePlaceholder: "ឈ្មោះ",
        phoneLabel: "ឧទាហរណ៍: +855 91234567",
        phonePlaceholder: "ទូរស័ព្ទ",
        buttonSumbitText: "បញ្ជាទិញ",
        doubleOrderAlert: "អ្នកបានដាក់ពាក្យរួចហើយ!",
    },
    {
        name: "BD",
        code: 880,
        minLengthTel: 5,
        nameLabel: "উদাহরণ: হাসান আহমেদ",
        namePlaceholder: "নাম",
        phoneLabel: "উদাহরণ: +880 1712345678",
        phonePlaceholder: "ফোন",
        buttonSumbitText: "অর্ডার করুন",
        doubleOrderAlert: "আপনি ইতিমধ্যেই আবেদন করেছেন!",
    },
    {
        name: "IN",
        code: 91,
        minLengthTel: 5,
        nameLabel: "उदाहरण: राजेश कुमार",
        namePlaceholder: "नाम",
        phoneLabel: "उदाहरण: +91 9812345678",
        phonePlaceholder: "फ़ोन",
        buttonSumbitText: "ऑर्डर करें",
        doubleOrderAlert: "आप पहले ही आवेदन कर चुके हैं!",
    },
    {
        name: "IT",
        code: 39,
        minLengthTel: 10,
        nameLabel: "Per esempio: Marco Rossi",
        namePlaceholder: "Nome",
        phoneLabel: "Per esempio: +39 3456789012",
        phonePlaceholder: "Telefono",
        buttonSumbitText: "Ordina",
        doubleOrderAlert: "Hai già fatto domanda!",
    },
    {
        name: "ES",
        code: 34,
        minLengthTel: 9,
        nameLabel: "Por ejemplo: Javier García",
        namePlaceholder: "Nombre",
        phoneLabel: "Por ejemplo: +34 612345678",
        phonePlaceholder: "Teléfono",
        buttonSumbitText: "Pedir",
        doubleOrderAlert: "¡Ya has presentado tu solicitud!",
    },
    {
        name: "FR",
        code: 33,
        minLengthTel: 5,
        nameLabel: "Par Exemple: Élodie Dupont",
        namePlaceholder: "Nom",
        phoneLabel: "Par exemple: +33 15225365",
        phonePlaceholder: "Numéro de téléphone",
        buttonSumbitText: "Commander",
        doubleOrderAlert: "Vous avez déjà postulé!",
    },
        {
        name: "GA",
        code: 241,
        minLengthTel: 5,
        nameLabel: "Par Exemple: Élodie Dupont",
        namePlaceholder: "Nom",
        phoneLabel: "Par exemple: +241 15225365",
        phonePlaceholder: "Numéro de téléphone",
        buttonSumbitText: "Commander",
        doubleOrderAlert: "Vous avez déjà postulé!",
    },
    {
        name: "GN",
        code: 224,
        minLengthTel: 5,
        nameLabel: "Par Exemple: Mamadou Diallo",
        namePlaceholder: "Nom",
        phoneLabel: "Par exemple: +224 541236521",
        phonePlaceholder: "Téléphone",
        buttonSumbitText: "COMMANDER",
        doubleOrderAlert: "Vous avez déjà postulé!",
    },
    {
        name: "CG",
        code: 242,
        minLengthTel: 5,
        nameLabel: "Par Exemple: Ange Mbemba",
        namePlaceholder: "Nom",
        phoneLabel: "Par exemple: +242 541236521",
        phonePlaceholder: "Téléphone",
        buttonSumbitText: "COMMANDER",
        doubleOrderAlert: "Vous avez déjà postulé!",
    },
    {
        name: "LV",
        code: 371,
        minLengthTel: 5,
        nameLabel: "Piemēram: Jānis Bērziņš",
        namePlaceholder: "Nosaukums",
        phoneLabel: "Piemēram: +371 933 543 342",
        phonePlaceholder: "Tālrunis",
        buttonSumbitText: "PASŪTĪJUMS",
        doubleOrderAlert: "Jūs jau esat pieteicies!",
    },
    {
        name: "US",
        code: 12,
        minLengthTel: 5,
        nameLabel: "For example: John Smith",
        namePlaceholder: "Name",
        phoneLabel: "For example: +12 933 543 342",
        phonePlaceholder: "Phone",
        buttonSumbitText: "ORDER",
        doubleOrderAlert: "You have already applied!",
    },
    {
        name: "CY",
        code: 357,
        minLengthTel: 5,
        nameLabel: "ΓΙΑ ΠΑΡΆΔΕΙΓΜΑ: Ανδρέας Παπαδόπουλος",
        namePlaceholder: "Όνομα",
        phoneLabel: "ΓΙΑ ΠΑΡΆΔΕΙΓΜΑ: +357 933 543 342",
        phonePlaceholder: "Τηλέφωνο",
        buttonSumbitText: "ΠΑΡΑΓΓΕΛΙΑ",
        doubleOrderAlert: "Έχετε ήδη υποβάλει αίτηση!",
    },
    {
        name: "SI",
        code: 386,
        minLengthTel: 5,
        nameLabel: "Na primer: Marija Novak",
        namePlaceholder: "Vaše Ime",
        phoneLabel: "Na primer: +386 41 679 845",
        phonePlaceholder: "Vaša telefonska številka",
        buttonSumbitText: "Izpolnite naročilo",
        doubleOrderAlert: "Ste se že prijavili!",
    },
    {
        name: "AT",
        code: 43,
        minLengthTel: 5,
        nameLabel: "Zum Beispiel: Anna Huber",
        namePlaceholder: "Name",
        phoneLabel: "Zum Beispiel: +43 933 543 342",
        phonePlaceholder: "Telefonnummer",
        buttonSumbitText: "BESTELLEN",
        doubleOrderAlert: "Sie haben sich bereits beworben!",
    },
    {
        name: "SE",
        code: 46,
        minLengthTel: 5,
        nameLabel: "Exempelvis: Erik Johansson",
        namePlaceholder: "Namn",
        phoneLabel: "Exempelvis: +46-49-123-456",
        phonePlaceholder: "Telefon",
        buttonSumbitText: "Beställa",
        doubleOrderAlert: "Du har redan ansökt!",
    },
    {
        name: "HR",
        code: 385,
        minLengthTel: 5,
        nameLabel: "Na primjer: Lana Barić",
        namePlaceholder: "Ime",
        phoneLabel: "Na primjer: +385-49-123-456",
        phonePlaceholder: "Telefonski broj",
        buttonSumbitText: "Naruči odmah",
        doubleOrderAlert: "Već ste se prijavili!",
    },
    {
        name: "EE",
        code: 372,
        minLengthTel: 5,
        nameLabel: "Näiteks: Aino Kask",
        namePlaceholder: "Nimi",
        phoneLabel: "Näiteks: +372-123-123-1234",
        phonePlaceholder: "Teie telefoninumber",
        buttonSumbitText: "Selleks",
        doubleOrderAlert: "Olete juba taotluse esitanud!",
    },
    {
        name: "FI",
        code: 358,
        minLengthTel: 5,
        nameLabel: "Esimerkiksi: Aino Virtanen",
        namePlaceholder: "Nimi",
        phoneLabel: "Esimerkiksi: +358-123-123-1234",
        phonePlaceholder: "Puhelinnumerosi",
        buttonSumbitText: "Tilata",
        doubleOrderAlert: "Olet jo hakenut!",
    },
    {
        name: "PT",
        code: 351,
        minLengthTel: 5,
        nameLabel: "Exemplo: Maria Braga",
        namePlaceholder: "Indique o seu nome",
        phoneLabel: "Exemplo: +351 686754536",
        phonePlaceholder: "Indique o seu número de telefone",
        buttonSumbitText: "Deixar um pedido",
        doubleOrderAlert: "Você já se inscreveu!",
    },
    {
        name: "MK",
        code: 389,
        minLengthTel: 5,
        nameLabel: "На пример: Јован Динески",
        namePlaceholder: "Внесете го вашето име",
        phoneLabel: "На пример: +389 71234567",
        phonePlaceholder: "Внесете го вашиот телефонски број",
        buttonSumbitText: "Нарачајте",
        doubleOrderAlert: "Веќе сте аплицирале!",
    },
    {
        name: "ME",
        code: 382,
        minLengthTel: 5,
        nameLabel: "Na primer: Marko Vuković",
        namePlaceholder: "Ime",
        phoneLabel: "Na primer: +382 98556431",
        phonePlaceholder: "Telefon",
        buttonSumbitText: "Naruči",
        doubleOrderAlert: "Već ste se prijavili!",
    },
    {
        name: "XK",
        code: 383,
        minLengthTel: 5,
        nameLabel: "Shembull: Arben Krasniqi",
        namePlaceholder: "Emër",
        phoneLabel: "Shembull: +383 98556431",
        phonePlaceholder: "Telefon",
        buttonSumbitText: "Porosit",
        doubleOrderAlert: "Ju keni aplikuar tashmë!",
    },
    {
        name: "AL",
        code: 355,
        minLengthTel: 5,
        nameLabel: "Shembull: Klevis Robo",
        namePlaceholder: "Emër",
        phoneLabel: "Shembull: +355 123456789",
        phonePlaceholder: "Telefon",
        buttonSumbitText: "Porosit",
        doubleOrderAlert: "Ju keni aplikuar tashmë!",
    },
    {
        name: "BG",
        code: 359,
        minLengthTel: 5,
        nameLabel: "Например: Стоян Стоянов",
        namePlaceholder: "Въведете име",
        phoneLabel: "Например: +359 777555888",
        phonePlaceholder: "Въведете телефонен номер",
        buttonSumbitText: "Поръчай",
        doubleOrderAlert: "Вече сте кандидатствали!",
    },
    {
        name: "GR",
        code: 30,
        minLengthTel: 10,
        nameLabel: "Για παράδειγμα: Γιώργος Παπαδόπουλος",
        namePlaceholder: "Όνομα",
        phoneLabel: "Για παράδειγμα: +30 933 543 342",
        phonePlaceholder: "Τηλέφωνο",
        buttonSumbitText: "Παραγγείλτε με",
        doubleOrderAlert: "Έχετε ήδη υποβάλει αίτηση!",
    },
    {
        name: "PL",
        code: 48,
        minLengthTel: 9,
        nameLabel: "Na przykład: Jan Kowalski",
        namePlaceholder: "Imię i nazwisko",
        phoneLabel: "Na przykład: +48780185369",
        phonePlaceholder: "Numer",
        buttonSumbitText: "Zamówić",
        doubleOrderAlert: "Już złożyłeś wniosek!",
    },
    {
        name: "RO",
        code: 40,
        minLengthTel: 9,
        nameLabel: "De exemplu: Ion Popescu",
        namePlaceholder: "Declarați numele dvs.",
        phoneLabel: "De exemplu: +40 989009736",
        phonePlaceholder: "Introduceți numărul dvs. de telefon",
        buttonSumbitText: "Comandă",
        doubleOrderAlert: "Ați aplicat deja!",
    },
    {
        name: "SK",
        code: 421,
        minLengthTel: 5,
        nameLabel: "Napríklad: Ján Novák",
        namePlaceholder: "Moje meno",
        phoneLabel: "Napríklad: +42143456726",
        phonePlaceholder: "Môj telefón",
        buttonSumbitText: "Objednávajte",
        doubleOrderAlert: "Už ste sa prihlásili!",
    },
    {
        name: "HU",
        code: 36,
        minLengthTel: 5,
        nameLabel: "Például: Kálmán Dániel",
        namePlaceholder: "Név",
        phoneLabel: "Például: +36 1111 11111",
        phonePlaceholder: "Telefonszám",
        buttonSumbitText: "MEGRENDELÉS",
        doubleOrderAlert: "Ön már jelentkezett!",
    },
    {
        name: "CZ",
        code: 420,
        minLengthTel: 5,
        nameLabel: "Například: Lukáš Novotný",
        namePlaceholder: "Vaše jméno",
        phoneLabel: "Například: +420 777888555",
        phonePlaceholder: "Zadejte telefonní číslo",
        buttonSumbitText: "Poslat",
        doubleOrderAlert: "Už jste podali přihlášku!",
    },
    {
        name: "BA",
        code: 387,
        minLengthTel: 5,
        nameLabel: "Primjer: Miljan Prljeta",
        namePlaceholder: "Tvoje ime",
        phoneLabel: "Primjer: +387 11 2910008",
        phonePlaceholder: "Tvoj broj telefona",
        buttonSumbitText: "Naruči",
        doubleOrderAlert: "Već ste se prijavili!",
    },
    {
        name: "RS",
        code: 381,
        minLengthTel: 5,
        nameLabel: "Na primjer: Ivan Stanković",
        namePlaceholder: "Unesite vaše ime",
        phoneLabel: "Na primjer: +38124876456",
        phonePlaceholder: "Unesite vaš broj telefona",
        buttonSumbitText: "Naruči",
        doubleOrderAlert: "Već ste se prijavili!",
    },
    {
        name: "LT",
        code: 370,
        minLengthTel: 5,
        nameLabel: "Pavyzdžiui: Jonas Petrauskas",
        namePlaceholder: "Vardas",
        phoneLabel: "Pavyzdžiui: +370 12345678",
        phonePlaceholder: "Telefonas",
        buttonSumbitText: "Užsakyti",
        doubleOrderAlert: "Jūs jau pateikėte paraišką!",
    },
    {
        name: "BE",
        code: 32,
        minLengthTel: 5,
        nameLabel: "Par Exemple: Sophie Dubois",
        namePlaceholder: "Nom et prénom",
        phoneLabel: "Par exemple: +32 541 236 521",
        phonePlaceholder: "Téléphone fixe",
        buttonSumbitText: "COMMANDEZ",
        doubleOrderAlert: "Vous avez déjà postulé!",
    },
    {
        name: "DE",
        code: 49,
        minLengthTel: 5,
        nameLabel: "Zum Beispiel: Hans Müller",
        namePlaceholder: "Name",
        phoneLabel: "Zum Beispiel: +49 933 543 342",
        phonePlaceholder: "Telefonnummer",
        buttonSumbitText: "Jetzt",
        doubleOrderAlert: "Sie haben sich bereits beworben!",
    },
    {
        name: "CH",
        code: 41,
        minLengthTel: 5,
        nameLabel: "Zum Beispiel: Wilhelm Stolz",
        namePlaceholder: "Ihr Name",
        phoneLabel: "Zum Beispiel: +41 548521478",
        phonePlaceholder: "Ihre Telefonnummer",
        buttonSumbitText: "Bestellen",
        doubleOrderAlert: "Sie haben sich bereits beworben!",
    },
    {
        name: "KZ",
        code: 7,
        minLengthTel: 5,
        nameLabel: "Например: Аян",
        namePlaceholder: "Имя",
        phoneLabel: "Например: +7 701 234 5678",
        phonePlaceholder: "Телефон",
        buttonSumbitText: "Заказать",
        doubleOrderAlert: "Вы уже подали заявку!",
    },
    {
        name: "QA",
        code: 971,
        minLengthTel: 5,
        nameLabel: '<label>مثال: فاطمة محمد</label>',
        namePlaceholder: "الاسم واللقب",
        phoneLabel: '<label>مثال: <bdo dir="ltr">+974 568574874</bdo></label>',
        phonePlaceholder: "رقم الهاتف",
        buttonSumbitText: "ارسل الطلب",
        doubleOrderAlert: "لقد تقدمت بالفعل!",
    },
    {
        name: "PS",
        code: 970,
        minLengthTel: 5,
        nameLabel: "<label>على سبيل المثال: أحمد الخطيب</label>",
        namePlaceholder: "الاسم الأول واسم العائلة",
        phoneLabel: '<label>على سبيل المثال:<span dir="ltr">+970 933 543 342</span></label>',
        phonePlaceholder: "رقم الهاتف",
        buttonSumbitText: "اطلب الآن",
        doubleOrderAlert: "لقد قمت بالتقديم مسبقًا!",
    },
    {
        name: "DZ",
        code: 213,
        minLengthTel: 5,
        nameLabel: "<label>على سبيل المثال: محمد بن علي</label>",
        namePlaceholder: "الاسم الكامل",
        phoneLabel: '<label>على سبيل المثال:<span dir="ltr">+213 933 543 342</span></label>',
        phonePlaceholder: "رقم الهاتف",
        buttonSumbitText: "اطلب الآن",
        doubleOrderAlert: "لقد قمت بالتقديم مسبقًا!",
    },
    {
        name: "MA",
        code: 212,
        minLengthTel: 9,
        nameLabel: "<label>على سبيل المثال: فاطمة الزهراء</label>",
        namePlaceholder: "الاسم الكامل",
        phoneLabel: '<label>على سبيل المثال:<span dir="ltr">+212 933 543 342</span></label>',
        phonePlaceholder: "رقم الهاتف",
        buttonSumbitText: "اطلب الآن",
        doubleOrderAlert: "لقد قمت بالتقديم مسبقًا!",
    },
    {
        name: "TN",
        code: 216,
        minLengthTel: 5,
        nameLabel: "<label>على سبيل المثال: علي الشاذلي</label>",
        namePlaceholder: "الاسم الكامل",
        phoneLabel: '<label>على سبيل المثال:<span dir="ltr">+216 933 543 342</span></label>',
        phonePlaceholder: "رقم الهاتف",
        buttonSumbitText: "اطلب الآن",
        doubleOrderAlert: "لقد قمت بالتقديم مسبقًا!",
    },
    {
        name: "LY",
        code: 218,
        minLengthTel: 5,
        nameLabel: "<label>على سبيل المثال: سارة المغربي</label>",
        namePlaceholder: "الاسم الكامل",
        phoneLabel: '<label>على سبيل المثال:<span dir="ltr">+218 933 543 342</span></label>',
        phonePlaceholder: "رقم الهاتف",
        buttonSumbitText: "اطلب الآن",
        doubleOrderAlert: "لقد قمت بالتقديم مسبقًا!",
    },
    {
        name: "EG",
        code: 20,
        minLengthTel: 5,
        nameLabel: "<label>على سبيل المثال: أحمد حمدي</label>",
        namePlaceholder: "الاسم الكامل",
        phoneLabel: '<label>على سبيل المثال:<span dir="ltr">+20 933 543 342</span></label>',
        phonePlaceholder: "رقم الهاتف",
        buttonSumbitText: "اطلب الآن",
        doubleOrderAlert: "لقد قمت بالتقديم مسبقًا!",
    },
    {
        name: "IQ",
        code: 964,
        minLengthTel: 5,
        nameLabel: "<label>على سبيل المثال: حسين العبيدي</label>",
        namePlaceholder: "الاسم الكامل",
        phoneLabel: '<label>على سبيل المثال:<span dir="ltr">+964 933 543 342</span></label>',
        phonePlaceholder: "رقم الهاتف",
        buttonSumbitText: "اطلب الآن",
        doubleOrderAlert: "لقد قمت بالتقديم مسبقًا!",
    },
    {
        name: "SA",
        code: 966,
        minLengthTel: 5,
        nameLabel: "<label>على سبيل المثال: نورة العتيبي</label>",
        namePlaceholder: "الاسم الكامل",
        phoneLabel: '<label>على سبيل المثال:<span dir="ltr">+966 933 543 342</span></label>',
        phonePlaceholder: "رقم الهاتف",
        buttonSumbitText: "اطلب الآن",
        doubleOrderAlert: "لقد قمت بالتقديم مسبقًا!",
    },
    {
        name: "AE",
        code: 971,
        minLengthTel: 5,
        nameLabel: "<label>على سبيل المثال: سالم المنصوري</label>",
        namePlaceholder: "الاسم الكامل",
        phoneLabel: '<label>على سبيل المثال:<span dir="ltr">+971 933 543 342</span></label>',
        phonePlaceholder: "رقم الهاتف",
        buttonSumbitText: "اطلب الآن",
        doubleOrderAlert: "لقد قمت بالتقديم مسبقًا!",
    },
    {
        name: "BH",
        code: 973,
        minLengthTel: 5,
        nameLabel: "<label>على سبيل المثال: هدى الخليفة</label>",
        namePlaceholder: "الاسم الكامل",
        phoneLabel: '<label>على سبيل المثال:<span dir="ltr">+973 933 543 342</span></label>',
        phonePlaceholder: "رقم الهاتف",
        buttonSumbitText: "اطلب الآن",
        doubleOrderAlert: "لقد قمت بالتقديم مسبقًا!",
    },
    {
        name: "KW",
        code: 965,
        minLengthTel: 5,
        nameLabel: "<label>على سبيل المثال: عبد الرحمن العتيبي</label>",
        namePlaceholder: "الاسم الكامل",
        phoneLabel: '<label>على سبيل المثال:<span dir="ltr">+965 933 543 342</span></label>',
        phonePlaceholder: "رقم الهاتف",
        buttonSumbitText: "اطلب الآن",
        doubleOrderAlert: "لقد قمت بالتقديم مسبقًا!",
    },
    {
        name: "OM",
        code: 968,
        minLengthTel: 5,
        nameLabel: "<label>على سبيل المثال: سعيد البوسعيدي</label>",
        namePlaceholder: "الاسم الكامل",
        phoneLabel: '<label>على سبيل المثال:<span dir="ltr">+968 933 543 342</span></label>',
        phonePlaceholder: "رقم الهاتف",
        buttonSumbitText: "اطلب الآن",
        doubleOrderAlert: "لقد قمت بالتقديم مسبقًا!",
    },
    {
        name: "JO",
        code: 962,
        minLengthTel: 5,
        nameLabel: "<label>على سبيل المثال: لينا خوري</label>",
        namePlaceholder: "الاسم الكامل",
        phoneLabel: '<label>على سبيل المثال:<span dir="ltr">+962 933 543 342</span></label>',
        phonePlaceholder: "رقم الهاتف",
        buttonSumbitText: "اطلب الآن",
        doubleOrderAlert: "لقد قمت بالتقديم مسبقًا!",
    },
    {
        name: "LB",
        code: 961,
        minLengthTel: 5,
        nameLabel: "<label>على سبيل المثال: جورج حداد</label>",
        namePlaceholder: "الاسم الكامل",
        phoneLabel: '<label>على سبيل المثال:<span dir="ltr">+961 933 543 342</span></label>',
        phonePlaceholder: "رقم الهاتف",
        buttonSumbitText: "اطلب الآن",
        doubleOrderAlert: "لقد قمت بالتقديم مسبقًا!",
    },
    {
        name: "PK",
        code: 92,
        minLengthTel: 5,
        nameLabel: "<label>مثال کے طور پر: علی خان</label>",
        namePlaceholder: "آپ کا نام",
        phoneLabel: '<label>مثال کے طور پر:<span dir="ltr">+92 933 543 342</span></label>',
        phonePlaceholder: "موبائل نمبر",
        buttonSumbitText: "آرڈر کریں",
        doubleOrderAlert: "آپ پہلے ہی درخواست دے چکے ہیں!",
    },
];